(function () {
  var ig = document.querySelector(".ig-embeds");
  if (!ig) return;
  /* load right after the page finishes, so embeds are ready before the user scrolls to them */
  function load() {
    var s = document.createElement("script");
    s.async = true;
    s.src = "https://www.instagram.com/embed.js";
    document.body.appendChild(s);
  }
  if (document.readyState === "complete") load();
  else window.addEventListener("load", load, { once: true });
})();
/* ---- next script block ---- */
const io = new IntersectionObserver(
  (es) => {
    es.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add("in");
        io.unobserve(e.target);
      }
    });
  },
  { threshold: 0.12 },
);
document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
(function () {
  var CARDS = [
    [
      "question",
      "How much privacy should a husband and wife have from others?",
      ZC.assetBase + "card-q-privacy.png",
    ],
    [
      "question",
      "How different are our cultures and how would they mix?",
      ZC.assetBase + "card-q-cultures.png",
    ],
    ["question", "How can someone regain your trust?", ZC.assetBase + "card-q-trust.png"],
    ["question", "What makes you happy?", ZC.assetBase + "card-q-happy.png"],
    [
      "question",
      "What traits would you absolutely not want in your spouse?",
      ZC.assetBase + "card-q-traits.png",
    ],
    [
      "question",
      "At what point would you consider getting a second wife?",
      ZC.assetBase + "card-q-second-wife.png",
    ],
    [
      "situation",
      "Your day hasn't been the best. How do you cheer yourself up?",
      ZC.assetBase + "card-s-cheer.png",
    ],
    [
      "situation",
      "1 year into your marriage your husband loses your job and money, what do you do?",
      ZC.assetBase + "card-s-job.png",
    ],
  ];
  var ICON = {
    question:
      '<svg width="100%" height="100%" viewBox="356 270 292 459" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M375.13 391.46C388.59 351.79 414.21 313.85 452.69 297.3C480.7 285.26 513.26 285.81 542.08 295.78C577.86 308.15 608.89 335.64 622.16 371.09C631.6 396.33 631.86 424.58 624.76 450.57C615.71 483.71 593.58 514.33 562.09 528.08C553.63 531.77 544.52 534.29 536.97 539.59C512.29 556.92 541.33 589.42 508.38 609.1C494.89 617.15 477.02 614.35 463.49 606.36C443.33 594.46 446.56 554.14 451.35 523.07C458.56 476.35 493.42 485.06 527.27 455.61C538.09 446.19 546.65 433.47 548.42 419.24C551.05 398.08 536.66 376.19 516.3 369.84C495.95 363.49 471.9 373.07 461.13 391.46C451.99 407.06 450.91 428.43 435.95 438.57C418.34 450.51 390.92 440.57 379.97 423.25C373.64 413.24 372.16 400.2 375.13 391.46Z" fill="#CD423C"/> <path d="M488.21 711.41C509.164 711.41 526.15 694.424 526.15 673.47C526.15 652.516 509.164 635.53 488.21 635.53C467.256 635.53 450.27 652.516 450.27 673.47C450.27 694.424 467.256 711.41 488.21 711.41Z" fill="#CD443C"/> <path d="M455.13 679.21C453.36 672.41 455.39 665.16 458.53 658.87C464.08 647.74 474.56 637.8 486.99 637.84C490.13 637.85 493.37 638.55 495.85 640.47C498.33 642.39 499.88 645.7 499.12 648.74C498.16 652.58 494.19 654.71 490.69 656.56C486.3 658.88 481.99 661.53 478.64 665.19C475.29 668.85 472.95 673.67 473.15 678.64C473.27 681.64 474.27 684.78 473.09 687.54C471.31 691.7 465.21 692.44 461.44 689.94C457.67 687.45 456.08 682.83 455.13 679.21Z" fill="#B1343B"/> <path d="M520.6 668.85C518.65 669.77 517.95 672.14 516.61 673.84C514.23 676.87 509.96 677.6 506.11 677.58C502.26 677.56 498.26 677.03 494.66 678.4C489.89 680.22 486.71 685.53 487.38 690.6C488.05 695.66 492.49 699.98 497.58 700.49C502.22 700.96 506.65 698.59 510.58 696.08C512.35 694.95 514.1 693.75 515.59 692.27C519.68 688.2 521.39 682.38 522.95 676.82C523.39 675.25 523.84 673.58 523.41 672C522.98 670.42 521.34 669.04 520.6 668.85Z" fill="#B1343B"/> <path d="M506.03 647.4C500.52 645.46 493.71 647.49 490.26 652.36C486.5 657.67 486.47 664.99 488.94 671.02C490.12 673.91 491.94 676.69 494.67 678.22C496.28 679.12 498.12 679.53 499.95 679.78C504.24 680.36 508.75 680.08 512.66 678.21C516.57 676.35 519.78 672.75 520.49 668.48C521.09 664.87 519.9 661.18 518.21 657.93C515.67 653.01 514.43 650.36 506.03 647.4Z" fill="#D86854"/> <path d="M494.12 654.84C492.37 658.04 491.59 662.61 492.45 666.48C493.29 670.27 495.96 673.6 499.47 675.24C501.74 676.3 504.38 676.66 506.77 675.95C508.43 675.46 509.9 674.5 511.31 673.49C513.08 672.22 514.83 670.81 515.95 668.94C518.04 665.46 517.55 660.8 515.29 657.43C513.03 654.06 509.25 651.92 505.3 651.01C503.39 650.56 497.05 649.47 494.12 654.84Z" fill="#EF8470"/> <path d="M504.18 653.74C503.48 653.46 502.76 653.22 502.01 653.18C499.12 653.03 497.22 654.71 497.18 657.22C497.11 661.29 502.34 663.46 503.48 667.37C503.7 668.11 503.76 668.9 504.06 669.61C504.64 670.96 506.09 671.81 507.56 671.9C509.02 671.99 510.47 671.39 511.61 670.46C514.94 667.75 515.4 662.41 513.13 658.76C511.04 655.4 507.61 655.12 504.18 653.74Z" fill="white"/> <path d="M455.8 673.46C455.26 686.83 463.45 700.14 475.62 705.7C487.79 711.25 503.21 708.71 512.96 699.55C514.62 697.99 516.22 695.93 515.85 693.68C515.37 690.79 511.73 689.41 508.89 690.11C506.04 690.82 503.79 692.9 501.46 694.69C496.38 698.59 490.15 701.36 483.75 701.06C477.35 700.76 470.91 696.88 468.84 690.82C466.82 684.9 469.08 678.08 466.71 672.3C466.19 671.03 465.4 669.79 464.21 669.1C462.56 668.14 460.37 668.42 458.79 669.5C457.21 670.57 455.85 672.26 455.8 673.46Z" fill="#903531"/> <path d="M460.28 660.82C460.85 662.38 460.36 664.29 461.34 665.63C462.69 667.46 465.81 666.65 467.12 664.79C468.43 662.93 468.57 660.53 469.08 658.31C469.93 654.61 471.93 651.19 474.74 648.64C475.42 648.03 476.16 647.44 476.56 646.62C476.96 645.8 476.89 644.66 476.13 644.15C475.4 643.66 474.42 643.95 473.61 644.3C466.62 647.31 457.89 654.25 460.28 660.82Z" fill="#903531"/> <path d="M434.75 354.32C434.75 358.74 436.84 363.52 441.05 364.86C444.42 365.93 448.4 365.32 451.32 363.32C470.87 349.94 486.91 331.28 526.24 340.01C591.3 354.46 588.29 414.69 579.52 434.12C572.2 450.34 566.65 460.56 557.61 469.6C552.51 474.7 552.4 486.11 559.24 490.78C571.3 499.02 583.23 488.44 587.49 484.19C606.3 465.38 610.02 452.42 614.4 426.12C618.24 403.11 614.34 381.44 604.91 360.1C592.37 331.7 560.79 309.23 523.3 307.22C485.62 305.21 434.75 336.69 434.75 354.32Z" fill="#D96854"/> <path d="M515.12 535.52C517.8 520.28 565.52 494.33 573.79 501.1C576.98 503.71 577.16 508.78 575.24 512.44C572.28 518.07 560.39 525.64 551.3 528.19C538.13 531.88 531.86 531.51 526.79 541.14C526.08 542.49 525.19 544.15 523.66 544.16C522.92 544.16 513.88 543.95 515.12 535.52Z" fill="#B2373B"/> <path d="M445.3 384.63C446.3 386.98 450.54 388.46 453.41 385.6C453.42 385.59 453.44 385.57 453.45 385.56C464.23 373.26 477.62 362.93 493.31 358.57C510.69 353.74 531.11 357.45 543.22 370.81C547.31 375.32 550.32 380.72 552.71 386.32C562.36 408.96 557.41 435.14 540.5 453.03C522.14 472.45 495.47 476.91 472.81 491.08C451.15 504.63 456.19 556.77 458.62 579.23C459.47 587.11 461.01 595.7 468.56 599.92C472.49 602.12 477.54 601.6 480.58 598.28C484.05 594.48 482.81 589.13 480.32 585.17C474.91 576.55 471.01 581.65 470.12 551.32C469.65 535.16 469.74 510.4 486.09 499.62C496.01 493.08 512.06 486.66 529.51 476.38C550.91 463.77 566.8 442.97 570.43 418.4C578.59 363.15 519.46 319.13 457.58 365.29C450.56 370.52 441.87 376.59 445.3 384.63Z" fill="#B1343B"/> <path d="M384.68 393.62C387.34 369.41 399.33 346.61 416.65 329.49C433.97 312.36 456.38 300.78 480.02 294.91C483.94 293.94 489.26 293.78 490.75 297.54C491.62 299.73 490.53 302.29 488.78 303.87C487.03 305.44 484.74 306.24 482.53 307.03C456.53 316.33 430.91 330.46 415.8 353.57C408.8 364.28 403.6 376.1 398.78 387.94C397.62 390.78 397.17 394.02 394.93 396.12C392.7 398.22 389.2 399.3 386.5 397.85C383.79 396.4 383.02 391.95 384.68 393.62Z" fill="#D86854"/> <path d="M423.9 410.43C433.057 410.43 440.48 403.007 440.48 393.85C440.48 384.693 433.057 377.27 423.9 377.27C414.743 377.27 407.32 384.693 407.32 393.85C407.32 403.007 414.743 410.43 423.9 410.43Z" fill="#D96854"/> <path d="M391.46 368.28C386.61 376.43 382.58 385.21 381.08 394.57C379.57 403.93 380.77 413.94 385.74 422.01C390.4 429.56 398.21 435.01 406.83 437.12C428.69 442.48 442.27 430.05 446.34 417.33C447.03 415.16 446.63 412.73 445.09 411.06C442.24 407.98 438.42 409.83 435.67 411.92C431.08 415.4 427.57 420.51 422.31 422.87C407.35 429.56 395.97 421.43 396.51 404.16C396.72 397.49 398.73 390.01 401.22 383.82C408.02 366.91 409.07 362.84 404.78 359.84C402.56 358.29 397.42 360.57 397.34 360.28C397.09 359.35 392.01 368.26 391.46 368.28Z" fill="#B1343B"/> <path d="M378.49 397.39C377.86 403.33 383.71 404.35 384.79 399.32C384.81 399.22 384.84 399.12 384.88 399.03C390.68 384.59 398.86 364.56 407.11 351.44C421.83 328.05 441.24 314.73 466.23 302.92C466.81 302.65 467.4 302.37 467.99 302.09C470.47 300.88 469.34 297.15 466.6 297.5C461.13 298.21 455.75 300.58 450.81 303.21C414.66 322.44 391.85 350.88 378.57 397C378.53 397.13 378.5 397.26 378.49 397.39Z" fill="#913432"/> <path d="M482.66 521.41C489.84 507.32 502.32 496 517.05 490.22C520.85 488.73 524.94 487.58 528.97 488.18C533.01 488.78 536.95 491.49 537.91 495.46C538.81 499.17 536.95 503.06 534.31 505.82C531.67 508.58 528.31 510.5 525.27 512.8C516.52 519.43 510.42 529.46 508.55 540.28C506.97 549.44 508.31 559.01 505.86 567.97C503.41 576.93 494.88 585.53 485.89 583.17C481 581.88 477.88 577.32 475.84 572.69C468.51 556.02 475.48 535.51 482.66 521.41Z" fill="#D96854"/> <path d="M454.05 546.23C453.71 537.15 454.35 528.04 455.98 519.1C457.25 512.08 459.21 505 463.36 499.2C469.67 490.39 480.11 485.71 489.95 481.18C511.17 471.41 532.86 459.66 545.31 439.9C546.41 438.16 547.84 436.13 549.89 436.24C551.6 436.33 552.89 438.04 553.06 439.75C553.23 441.46 552.55 443.13 551.79 444.67C545.5 457.32 533.05 465.54 521.16 473.17C508.25 481.45 479.02 495.87 475.69 498C459.86 508.14 462.9 540.29 461.34 547.29C460.97 548.94 460.19 550.77 458.57 551.24C456.87 551.73 455.09 550.37 454.47 548.72C453.85 547.07 454.08 545.21 454.05 546.23Z" fill="#913432"/> <path d="M481.49 370.22C491.61 362.82 501.54 361.5 513.88 363.67C526.23 365.84 537.57 373.21 544.57 383.61C544.94 384.16 545.3 384.72 545.8 385.14C547.59 386.67 550.6 385.84 551.95 383.91C553.3 381.98 553.31 379.4 552.78 377.11C551.53 371.77 547.71 367.39 543.49 363.89C526.48 349.77 500.64 347.39 481.34 358.17C475.44 361.47 470.39 366.13 473.83 370.51C475.46 372.61 478.93 372.21 481.49 370.22Z" fill="#913432"/> <path d="M454.61 569.55C454.18 570.51 454.03 571.58 454.09 572.64C454.38 578.39 454.75 584.18 456.39 589.7C460.91 604.88 474.6 609.23 482.45 610.67C507.87 615.32 520.19 593.23 521.66 589.06C523.18 584.75 523.05 579.64 520.25 575.97C510.42 563.08 500.94 604.63 479.99 601.92C458.29 599.11 462.5 571.54 459.46 568.45C457.64 566.64 455.38 567.82 454.61 569.55Z" fill="#913432"/> <path d="M583.38 510.18C599.72 496.77 614.92 477.2 618.85 456.3C620.98 444.96 606.39 433.09 597.55 457.91C587.91 484.97 571.93 511.81 545.98 524.12C539.85 527.03 527.73 532.03 529.74 535.68C531.12 537.66 532.66 538.01 534.9 537.17C534.9 537.29 568.16 522.67 583.38 510.18Z" fill="#913432"/> <path d="M524.15 311.9C522.22 312.45 521.17 314.55 521.89 316.43C523.82 321.43 529.16 325.08 534.2 327.62C549.86 335.51 567.72 340.47 579.74 353.24C591.53 365.76 595.55 383.69 596.93 400.84C597.28 405.27 597.52 409.82 599.35 413.87C601.18 417.92 605.05 421.4 609.49 421.31C613.43 421.24 616.92 418.33 618.65 414.79C620.38 411.25 620.64 407.17 620.49 403.22C619.72 383.12 609.31 364.78 598.43 347.87C586.41 329.19 571.18 309.61 549.29 305.83C542.48 304.65 538.42 303.67 535.8 309.44C534.85 311.51 526.36 311.27 524.15 311.9Z" fill="#F38571"/> <path d="M381.34 405.98C382.83 405.58 384.43 406.38 385.43 407.54C386.44 408.7 386.99 410.18 387.57 411.61C393.18 425.34 404.1 436.32 417.93 436.21C417.9 437.04 416.88 437.4 416.06 437.52C399.81 439.88 388.35 427.65 385.05 423.89C382.13 420.57 379.82 416.63 378.86 412.32C378.61 411.21 378.45 410.06 378.69 408.95C378.93 407.84 379.85 406.38 381.34 405.98Z" fill="#913432"/> <path d="M597.3 346.07C590.76 336.24 583.87 326.07 573.66 320.13C571.12 318.65 567.66 317.55 565.44 319.48C564.13 320.62 563.73 322.55 564.06 324.26C564.39 325.96 565.35 327.48 566.4 328.86C570.41 334.11 575.98 337.9 581.11 342.07C593.4 352.06 603.83 365.34 606.71 380.92C607.23 383.74 607.55 386.74 609.26 389.04C610.96 391.35 614.67 392.47 616.7 390.45C618.53 388.63 617.97 385.58 617.2 383.11C610.49 361.54 597.89 341.84 581.12 326.7" fill="white"/> <path d="M547.24 308.67C545.98 309.19 545.57 310.83 545.81 312.17C546.19 314.27 547.7 316.01 549.44 317.24C550.87 318.25 552.52 319 554.26 319.14C556 319.28 557.84 318.75 559.08 317.52C560.32 316.28 560.84 314.3 560.15 312.69C559.68 311.6 558.74 310.79 557.77 310.11C554.99 308.19 551.46 307.07 548.2 307.95C547.59 308.11 546.97 308.36 546.58 308.85C545.93 309.65 546.07 310.81 546.24 311.83" fill="white"/> <path d="M513.15 675.23C512.21 673.63 510.54 674.24 509.88 675.23C509.09 676.43 509.18 678.01 508.54 679.3C508.3 679.79 507.95 680.22 507.74 680.72C506.23 684.24 511.14 685.24 513.08 680.92C513.82 679.27 514.21 677.11 513.15 675.23Z" fill="white"/> </svg>',
    situation:
      '<svg width="100%" height="100%" viewBox="322 310 373 334" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M507 328.54C521.91 327.24 523.93 339.66 541.17 369.87C595.52 465.15 641.36 545.08 664.38 580.94C675.62 598.45 678.29 611.21 676.82 614.84C673.55 622.93 664.43 624.92 655.71 624.92C554.38 624.13 403.25 624.04 372.43 625.92C353.94 627.05 348.22 625.99 342.26 614.72C334.49 600.01 348.04 589.15 361.65 566.49C379.68 536.46 444.35 428.13 472.24 372.87C492 333.72 495.46 329.55 507 328.54Z" fill="#F6B25F"/> <path d="M445.68 445.58C417.03 495.49 387.72 545.01 357.75 594.14C355.22 598.29 352.58 603.03 353.75 607.75C355.46 614.62 363.85 617.06 370.88 617.89C383 619.32 395.26 619.6 407.44 618.71C422.12 617.64 436.72 614.89 451.42 615.36C461.23 615.67 470.99 617.41 480.8 617.22C490.62 617.03 500.89 614.62 508.02 607.87C517.47 598.94 519.05 582.87 511.51 572.27C505.62 563.99 495.53 559.51 489.49 551.35C480.21 538.83 482.78 521.15 488.35 506.6C493.92 492.05 502.15 478.05 503.15 462.49C504.15 446.94 494.24 429.01 478.66 428.57C465.05 428.18 455.04 440.42 445.68 445.58Z" fill="#EEA461"/> <path d="M398.95 543.58C388.02 557.56 377.94 572.2 368.76 587.4C365.64 592.56 362.59 599.06 365.55 604.32C368.1 608.84 373.96 610.17 379.14 610.45C395.34 611.33 411.44 606.59 427.64 607.39C433.24 607.67 438.87 608.6 444.41 607.78C449.95 606.96 455.61 603.91 457.6 598.67C460.61 590.71 453.91 582.25 446.5 578.06C439.09 573.87 430.33 571.66 424.39 565.56C419.92 560.97 417.61 554.7 413.53 549.77C409.45 544.84 401.29 540.59 398.95 543.58Z" fill="#EC9A42"/> <path d="M496.56 353.13C475.96 386.64 456.95 421.12 439.6 456.42C434.56 466.69 429.59 477.23 427.97 488.56C426.35 499.89 428.54 512.3 436.32 520.69C444.2 529.19 457.06 532.28 468.27 529.32C479.47 526.36 488.82 517.84 493.86 507.4C498.88 497.02 500.03 484.74 507 475.56C513.76 466.65 525.22 462.1 536.4 461.88C540.91 461.79 545.77 462.25 549.6 459.87C555.74 456.06 555.99 447.32 555.02 440.17C551.33 412.97 540.19 386.83 523.14 365.32C519.1 360.23 514.43 355.18 508.22 353.25C502.03 351.31 494.04 353.75 496.56 353.13Z" fill="#F7C574"/> <path d="M468.55 399.6C451.98 430.08 435.08 460.39 417.87 490.51C411.53 501.6 404.93 513.71 406.58 526.37C408.5 541.13 421.69 552.51 436.03 556.5C450.37 560.49 465.41 554.31 480.25 555.53C518.9 558.72 536.6 541.31 567.65 564.41C580.54 574 590.14 587.4 602.68 597.43C615.23 607.46 633.03 613.85 647.3 606.48C649.41 605.39 651.44 603.96 652.62 601.91C654.87 597.98 653.43 593.02 651.65 588.86C643.58 569.97 629.7 554.3 617.1 538.08C601.37 517.84 587.32 496.28 575.17 473.71C559.47 444.56 545.06 411.69 515.93 395.95C507.6 391.44 498.08 388.58 488.66 389.66C479.26 390.74 470.29 396.4 468.55 399.6Z" fill="#F5AC45"/> <path d="M430.28 472.1C450.18 429.15 471.77 386.98 494.97 345.73C497.9 340.52 502.79 334.49 508.49 336.29C511.68 337.3 513.58 340.47 515.2 343.39C547.7 402.23 580.2 461.06 612.71 519.9C619.38 531.98 626.06 544.07 633.61 555.62C641.13 567.13 649.52 578.13 655.57 590.48C656.97 593.35 657.98 597.4 655.36 599.23C653.16 600.77 650.15 599.39 647.93 597.88C634.47 588.74 624.51 575.4 615.26 562.01C605.28 547.58 595.81 532.79 586.87 517.69C578.76 503.98 570.91 489.78 559.34 478.83C547.77 467.88 531.52 460.51 515.93 463.77C493.32 468.5 478.85 493.36 456.08 497.26C452.18 497.93 448.08 497.92 444.35 496.58C432.87 492.47 427.9 477.25 430.28 472.1Z" fill="#FBB95A"/> <path d="M488.44 361.11C471.95 386.5 457.63 413.3 445.66 441.11C443.17 446.91 440.74 452.89 440.32 459.19C439.9 465.49 441.79 472.27 446.66 476.3C452.32 480.99 460.75 480.93 467.58 478.19C474.4 475.46 480.05 470.5 485.73 465.84C493.11 459.79 500.92 454.04 509.84 450.67C518.76 447.29 529 446.5 537.74 450.32C542.3 452.31 546.3 455.48 550.97 457.2C555.64 458.93 561.58 458.81 564.81 455.03C566.9 452.59 567.4 449.16 567.31 445.94C566.77 426.67 549.4 412.83 539.55 396.26C531.83 383.28 528.33 367.62 517.92 356.67C514.41 352.98 509.79 349.82 504.7 349.96C497.1 350.17 491.22 356.81 488.44 361.11Z" fill="#F7C574"/> <path d="M495.97 360.91C488.67 368.37 481.18 376.14 477.5 385.9C473.82 395.67 474.96 408.06 483.01 414.71C490.4 420.82 501 420.48 510.13 423.39C520.56 426.71 529.76 434.52 540.7 434.68C544.1 434.73 547.68 433.92 550.17 431.61C555 427.12 553.93 419.29 551.98 412.99C544.68 389.38 530.22 368.02 511 352.47C509.64 351.37 508.21 350.27 506.51 349.88C503.45 349.16 500.24 350.96 498.36 353.48C496.48 356 495.66 359.12 495.97 360.91Z" fill="#F8CC7B"/> <path d="M489.3 354.21C493.92 347.79 497.1 339.27 506.3 339.23C513.95 339.2 519.29 346.54 523.28 353.07C549.05 395.33 651.94 580.16 661.73 599.18C669.14 613.59 660.28 617.48 642.85 617.48C622.72 617.48 629.05 605.53 633.3 605.42C634.84 605.38 636.27 606.18 637.78 606.45C642.99 607.37 647.3 601.44 646.91 596.17C646.46 590.1 572.41 456.32 511.87 354.8C509.11 350.17 504.41 350.79 500.38 356.78C499.37 358.28 497.1 361.81 496.09 363.3C493.37 367.33 489.76 366.98 487.39 362.72C485.68 359.65 488.62 355.15 489.3 354.21Z" fill="#F5D79F"/> <path d="M517.29 336.76C514.36 335.63 510.37 339.62 512.7 345.12C512.81 345.39 512.87 345.69 512.99 345.96C519.49 361.27 558.39 416.01 572.87 443.25C597.2 489.03 623.65 542.95 627.92 544.82C632.62 546.88 631.55 541.81 630.33 539.34C629.39 537.43 566.92 421.95 566.92 421.95C551.53 393.7 522.61 337.14 517.29 336.76Z" fill="#FAECC5"/> <path d="M632.91 546.24C632.26 545.93 631.44 546.06 630.84 546.46C630.24 546.86 629.83 547.5 629.57 548.18C629.38 548.67 629.27 549.19 629.3 549.71C629.35 550.5 629.75 551.25 630.32 551.79C630.75 552.19 631.27 552.5 631.84 552.66C632.46 552.84 633.12 552.85 633.77 552.86C633.99 552.86 634.21 552.87 634.42 552.79C634.62 552.72 634.78 552.59 634.93 552.45C635.93 551.5 636.32 549.95 635.87 548.64C635.42 547.34 634.05 546.79 632.91 546.24Z" fill="#FAECC5"/> <path d="M618.41 612.59C617.76 612.28 616.94 612.41 616.34 612.81C615.74 613.21 615.33 613.85 615.07 614.53C614.88 615.02 614.77 615.54 614.8 616.06C614.85 616.85 615.25 617.6 615.82 618.14C616.25 618.54 616.77 618.85 617.34 619.01C617.96 619.19 618.62 619.2 619.27 619.21C619.49 619.21 619.71 619.22 619.92 619.14C620.12 619.07 620.28 618.94 620.43 618.8C621.43 617.85 621.82 616.3 621.37 614.99C620.92 613.69 619.55 613.14 618.41 612.59Z" fill="#D58036"/> <path d="M478.41 368.88C446.07 435.54 409.74 500.27 369.68 562.59C362.3 574.08 354.78 585.5 348.21 597.47C345.37 602.65 342.59 608.64 348.64 614.5C348.86 614.72 349.11 614.92 349.36 615.1C354.67 618.9 360.93 618.68 366.97 618.44C444 615.46 521.14 615.68 598.15 619.09C601.62 619.24 605.34 619.29 608.9 618.87C613.73 618.31 613.37 611.19 608.51 611.1C467.28 608.45 367.39 609.84 363.61 609.66C357.89 609.38 354.42 605.42 358.78 597.73C361.44 593.04 480.62 376.46 487.54 367.92C490.6 364.18 481.58 363.01 478.41 368.88Z" fill="#D68038"/> <path d="M493.03 527.09C491.23 492.42 489.43 457.71 490.54 423.01C490.75 416.41 491.12 409.58 494.11 403.69C497.1 397.8 503.43 393.09 509.96 394.07C515.62 394.92 520 399.8 521.94 405.17C523.88 410.55 523.84 416.41 523.77 422.13C523.59 437.83 523.4 453.53 523.22 469.23C523 488.08 522.78 506.94 522.55 525.79C522.51 529.14 522.45 532.59 521.13 535.66C518.2 542.49 509.07 545.46 502.26 542.46C495.45 539.46 493.28 531.86 493.03 527.09Z" fill="#414550"/> <path d="M507 592.62C516.113 592.62 523.5 585.233 523.5 576.12C523.5 567.007 516.113 559.62 507 559.62C497.887 559.62 490.5 567.007 490.5 576.12C490.5 585.233 497.887 592.62 507 592.62Z" fill="#414550"/> <path d="M493.56 432.17C493.98 427.34 495.87 424.39 498.72 422.37C501.57 420.35 505.76 420.49 508.46 422.7C511.52 425.2 512.32 429.49 512.74 433.42C516.04 464.07 509.21 495.5 516.25 525.64C516.81 528.05 516.93 530.57 516.3 532.96C513.78 542.51 503.48 540.25 499.56 534.45C496.55 530 496.26 524.32 496.06 518.95C495.32 499.07 494.59 479.19 493.85 459.31C493.44 448.38 493.02 438.42 493.56 432.17Z" fill="#4A4E58"/> <path d="M493.7 578.41C493.02 574.38 494.87 569.95 498.37 567.84C501.87 565.72 506.84 566.25 509.62 569.24C510.52 570.21 511.18 571.38 511.64 572.61C512.99 576.23 512.48 580.56 510.09 583.6C507.7 586.64 503.41 588.14 499.72 586.97C496.03 585.81 494.28 581.86 493.7 578.41Z" fill="#4A4E58"/> <path d="M505.51 561.57C504.98 562.37 505.22 563.49 505.79 564.26C506.36 565.03 507.2 565.55 507.98 566.11C510.79 568.11 513.14 570.9 514.08 574.22C515.02 577.54 514.39 581.39 512.01 583.89C511.23 584.72 510.27 585.4 509.67 586.37C509.07 587.34 508.97 588.76 509.84 589.5C510.22 589.82 510.73 589.96 511.23 590.02C513.42 590.28 515.58 589.21 517.21 587.73C520.66 584.58 522.06 579.51 521.23 574.92C520.4 570.33 517.54 566.23 513.8 563.42C511.92 562 509.71 560.85 507.35 560.84C506.29 560.8 504.89 561.57 505.51 561.57Z" fill="#3C3C4B"/> <path d="M504.76 588.06C504.11 588.37 503.73 589.14 503.83 589.86C503.93 590.57 504.47 591.19 505.15 591.44C505.83 591.69 506.61 591.57 507.22 591.19C507.43 591.06 507.62 590.9 507.75 590.7C507.96 590.39 508.02 589.99 508 589.62C507.99 589.39 507.96 589.16 507.85 588.96C507.72 588.72 507.51 588.55 507.29 588.39C506.91 588.12 506.49 587.89 506.04 587.8C505.58 587.7 505.14 587.88 504.76 588.06Z" fill="#3C3C4B"/> <path d="M496.99 407.75C497.05 404.11 499.22 400.59 502.43 398.88C505.64 397.17 509.78 397.35 512.83 399.33C517.64 402.45 519.05 408.96 519.59 414.5C520.04 419.04 520.19 423.6 520.18 428.17C520.09 458.38 521.27 521.72 519.9 518.8C516.73 520.33 516.27 513.08 516.27 509.77C516.27 493.03 515.54 448.31 515.83 432.59C515.9 428.85 515.94 424.99 514.56 421.52C513.17 418.05 509.96 415.02 506.22 415.03C504.02 415.04 501.73 416.06 499.7 415.22C496.7 413.99 496.95 409.96 496.99 407.75Z" fill="#3B3B4B"/> </svg>',
    action:
      '<svg width="100%" height="100%" viewBox="265 261 471 480" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M318.37 676.82V512.87C318.37 487.45 338.98 466.84 364.4 466.84H652.35C677.77 466.84 698.38 487.45 698.38 512.87V676.82C698.38 702.24 677.77 722.85 652.35 722.85H364.39C338.97 722.85 318.37 702.24 318.37 676.82Z" fill="#232827"/> <path d="M330.21 525.83C334.35 635.4 318.62 706.59 359.35 710.17C458.84 718.93 493.47 718 492.75 676.88C492.52 663.86 480.28 653.24 480.05 640.21C479.85 628.91 485.52 618.32 492.32 609.29C503.72 594.16 518.79 581.82 535.86 573.62C549.65 567 565.05 562.81 576.37 552.52C587.69 542.23 592.74 522.57 581.68 512C576.39 506.95 568.84 505.23 561.67 503.82C502.79 492.25 442.48 488.02 382.57 491.26C371.43 491.86 359.7 492.92 350.52 499.27C339.99 506.54 334.9 519.26 330.21 525.83Z" fill="#343B3A"/> <path d="M346.95 550.58C343.26 587.03 342.62 623.8 345.06 660.36C345.49 666.84 346.07 673.52 349.06 679.29C355.07 690.89 368.87 695.71 381.42 699.38C395.61 703.53 411.16 707.46 424.81 701.79C441.27 694.96 449.41 676.54 454.02 659.33C458.63 642.12 461.74 623.49 473.6 610.19C487.33 594.79 511.68 587.78 517.41 567.96C521.44 554 513.61 538.68 501.86 530.13C490.11 521.58 475.27 518.58 460.82 517.08C444.75 515.4 428.52 515.3 412.44 516.77C399.19 517.98 385.85 520.32 373.82 526C361.78 531.68 348 540.22 346.95 550.58Z" fill="#3B4343"/> <path d="M356.18 544.47C354.83 564.47 353.49 584.46 352.14 604.46C351.63 612 351.17 619.82 353.93 626.85C356.69 633.88 363.67 639.86 371.16 638.91C375.37 638.37 379.05 635.79 382.13 632.86C393.78 621.8 399.33 605.18 411.97 595.27C420.47 588.61 431.24 585.74 441.5 582.37C451.76 579 462.33 574.62 468.93 566.06C475.52 557.5 476.33 543.63 467.96 536.81C462.91 532.69 455.97 532.03 449.47 531.53C426.02 529.74 402.43 527.95 379.01 530.11C373.75 530.59 368.35 531.33 363.77 533.97C359.19 536.62 356.38 541.55 356.18 544.47Z" fill="#3F4748"/> <path d="M516.54 709.79C556.26 711.46 596.04 711.61 635.77 710.23C646.8 709.85 658.59 709.08 667.38 702.4C676.45 695.5 680.28 683.82 683.11 672.78C689.42 648.12 686.36 591.93 686.36 566.47C686.36 520.99 646.99 504.79 632.36 557.26C613.96 623.23 613.33 653.35 538.33 679.95C524.01 685.03 491.96 682.23 506.01 703.7C509.06 708.36 514.52 709.79 516.54 709.79Z" fill="black"/> <path d="M323.31 534.27C319.42 540.48 322.75 549.93 329.68 552.33C333.39 553.61 337.44 553.05 341.33 552.5C432.84 539.5 525.75 541.56 618.15 543.64C636.86 544.06 655.91 544.54 673.66 550.47C676.39 551.38 679.13 552.43 682 552.6C687.28 552.91 692.61 549.92 695.1 545.25C697.59 540.58 697.1 534.49 693.89 530.28C690.27 525.52 684.1 523.62 678.29 522.19C648.5 514.89 617.65 513.19 586.99 512.39C513.15 510.45 439.19 513.52 365.76 521.58C350.57 523.23 330.82 522.3 323.31 534.27Z" fill="black"/> <path d="M298.37 524.88V477.82C298.37 471.76 303.28 466.85 309.34 466.85H707.4C713.46 466.85 718.37 471.76 718.37 477.82V524.88C718.37 530.94 713.46 535.85 707.4 535.85H309.34C303.28 535.85 298.37 530.93 298.37 524.88Z" fill="#C3C9CF"/> <path d="M422.01 474.32C478.06 474.46 645.69 472.75 678.44 472.75C678.44 472.75 692.25 472.32 706.25 473.36C708.09 473.5 709.65 475.66 708.42 478.86C708.42 501.16 707.41 523.9 707 525.87C705.77 531.78 701.23 531.95 697.23 531.94C637.22 531.76 577.2 531.58 517.19 531.39C491.67 531.31 487.74 514 506.86 508.23C506.86 508.23 528.11 499.04 522.16 487.91C519.21 482.4 516.11 474.68 427.98 486.45C421.62 487.3 417.7 491.3 414.93 480.14C413.47 474.25 421.06 474.32 422.01 474.32Z" fill="#AEB3BA"/> <path d="M307.43 476.92C306.04 489.05 305.33 501.26 305.3 513.48C305.29 517.83 305.48 522.5 308.09 525.97C312.02 531.18 319.58 531.55 326.1 531.43C374.12 530.6 422.14 529.76 470.16 528.93C473.86 528.87 478.01 528.61 480.48 525.85C483.82 522.13 482.19 516.13 484.11 511.52C488.11 501.89 503.98 503.63 509.55 494.82C510.1 493.94 510.54 492.93 510.44 491.89C510.18 489.23 506.86 488.23 504.2 487.94C478.38 485.17 452.43 489.82 426.53 491.75C418.7 492.33 409.62 492.16 404.63 486.09C402.37 483.33 401.17 479.55 398.11 477.73C396.13 476.55 393.72 476.43 391.42 476.33C366.86 475.32 342.3 474.32 317.74 473.31C315.27 473.21 312.68 473.13 310.48 474.25C308.27 475.38 306.68 478.13 307.43 476.92Z" fill="#D2D6DA"/> <path d="M367.4 469.37C370.7 469.4 368.01 471.58 367.93 471.65C347.07 490.18 327.09 509.42 307.92 529.5C306.31 531.18 303.48 530.45 302.9 528.2C301.05 521.12 301.15 507.37 301.15 486.87C301.15 473.9 300.9 472.01 308.24 470.19C313.38 468.91 349.27 469.3 367.4 469.37Z" fill="#222A27"/> <path d="M650 533.37C646.7 533.34 649.39 531.16 649.47 531.09C670.33 512.56 690.31 493.32 709.48 473.24C711.09 471.56 713.92 472.29 714.5 474.54C716.35 481.62 716.25 495.37 716.25 515.87C716.25 528.84 716.5 530.73 709.16 532.55C704.02 533.82 668.13 533.44 650 533.37Z" fill="#222A27"/> <path d="M579.73 470.18C599.28 469.44 618.85 469.4 638.4 470.07C639.87 470.12 640.54 471.94 639.46 472.94C618.17 492.55 596.25 511.48 573.74 529.68C572.01 531.08 570.24 532.49 568.15 533.24C566.01 534.01 563.68 534.02 561.41 534.03C542.72 534.08 524.04 534.13 505.35 534.17C503.79 534.17 503.1 532.2 504.34 531.24C529.66 511.46 554.58 491.22 578.72 470.58C579.01 470.33 579.36 470.19 579.73 470.18Z" fill="#232827"/> <path d="M445.47 469.64C465.58 468.87 485.71 468.85 505.82 469.57C506.75 469.6 507.18 470.76 506.49 471.39C484.86 491.36 462.58 510.62 439.69 529.13C437.96 530.53 436.19 531.94 434.1 532.69C431.96 533.46 429.63 533.47 427.36 533.48C408.09 533.53 388.82 533.58 369.54 533.63C368.55 533.63 368.12 532.38 368.9 531.77C394.75 511.61 420.2 490.95 444.83 469.89C445.02 469.74 445.24 469.65 445.47 469.64Z" fill="#242A27"/> <path d="M382.97 527.98C399.4 513.51 415.83 499.03 432.5 484.83C436.34 481.56 440.26 478.26 444.85 476.16C453.17 472.37 462.73 472.92 471.85 473.55C471.32 477.91 466.73 480.38 462.76 482.24C435.81 494.92 411.8 512.95 386.56 528.75C385.76 529.25 384.88 529.77 383.95 529.67C383.02 529.57 382.23 528.63 382.97 527.98Z" fill="#343B3A"/> <path d="M515.14 528.54C534.1 514.67 552.08 499.46 568.91 483.08C571.55 480.51 574.21 477.87 577.47 476.15C581.83 473.84 586.91 473.34 591.84 473.01C605.32 472.1 618.87 472.08 632.35 472.95C629.49 478.48 624.78 483.04 619.15 485.72C611.68 489.27 603.1 489.44 595.07 491.39C567.9 498 548.79 524.34 521.53 530.57C519.06 531.13 515.82 531.17 514.74 528.88C515.34 528.13 515.93 527.38 515.14 528.54Z" fill="#343B3A"/> <path d="M699.24 331.82L685.68 286.76C683.93 280.96 677.82 277.67 672.01 279.41L290.84 394.09C285.04 395.84 281.75 401.95 283.49 407.76L297.05 452.82C298.8 458.62 304.91 461.91 310.72 460.17L691.9 345.48C697.7 343.74 700.99 337.62 699.24 331.82Z" fill="#C3C9CF"/> <path d="M566.45 318.46C512.82 334.74 351.8 381.4 320.44 390.83C320.44 390.83 300.94 393.92 293.99 399.43C292.54 400.58 291.4 402.61 293.5 405.32C299.93 426.68 307.45 448.16 308.41 449.93C311.29 455.24 315.69 454.09 319.51 452.93C376.93 435.47 434.34 418 491.76 400.54C516.17 393.11 514.95 375.41 494.98 375.38C494.98 375.38 471.98 372.7 474.48 360.33C475.72 354.2 476.47 345.92 564.24 331.8C570.57 330.78 575.49 333.48 574.92 322C574.61 315.94 567.36 318.19 566.45 318.46Z" fill="#D1D6DB"/> <path d="M676.93 287.94C681.76 299.16 685.96 310.65 689.5 322.33C690.76 326.49 691.93 331.02 690.43 335.1C688.17 341.22 681.04 343.75 674.75 345.52C628.53 358.56 585.8 374.09 539.58 387.13C523.13 391.77 524.85 380.7 517.7 371.97C511.09 363.91 496.4 370.14 488.53 363.3C487.75 362.62 487.03 361.77 486.84 360.75C486.33 358.13 489.21 356.21 491.67 355.17C515.6 345.08 541.79 342.05 567.14 336.45C574.81 334.75 583.45 331.97 586.48 324.72C587.85 321.43 587.91 317.46 590.32 314.84C591.88 313.14 594.15 312.33 596.32 311.58C619.55 303.54 642.78 295.5 666.01 287.46C668.34 286.65 670.81 285.83 673.24 286.27C675.67 286.71 677.99 288.88 676.93 287.94Z" fill="#AEB3BA"/> <path d="M532.84 391.28C578.14 376.79 622.15 362.9 668.05 350.44C675.67 348.37 683.36 346.3 690.36 342.65C692.22 341.68 694.1 340.53 695.21 338.74C696.32 336.95 696.42 334.38 694.9 332.92C693.39 331.47 690.88 331.64 689.03 332.62C687.18 333.6 685.77 335.22 684.18 336.59C676.2 343.47 605.87 361.4 534.99 387.62C532.71 388.46 528.4 389.42 529.23 391.23C529.91 392.32 531.26 391.83 532.84 391.28Z" fill="#A1A7AE"/> <path d="M309.82 399.28C309.51 395.73 311.86 392.38 314.85 390.45C317.84 388.52 321.4 387.71 324.87 386.91C381.54 373.73 435.43 350.37 492.04 336.93C492.96 336.71 494.11 336.58 494.66 337.35C494.94 337.74 494.96 338.26 494.89 338.74C494.41 342.18 490.6 343.93 487.37 345.22C481.09 347.71 475.03 350.72 469.25 354.22C464.22 357.27 458.76 362.51 460.77 368.04C461.86 371.03 464.93 372.99 465.91 376.02C466.95 379.24 465.32 382.75 463.12 385.33C458 391.34 449.99 394.2 442.14 395.1C434.29 396.01 426.36 395.23 418.46 395.3C404.04 395.42 389.65 398.42 376.38 404.05C365.91 408.49 355.89 414.63 344.61 416.12C335.4 417.33 325.78 415.22 317.92 410.24C312.91 407.07 310.47 402.78 309.82 399.28Z" fill="#E6E7EA"/> <path d="M477.52 342.87C432.22 357.36 388.21 371.25 342.31 383.71C334.69 385.78 327 387.85 320 391.5C318.14 392.47 316.26 393.63 315.15 395.41C314.04 397.2 313.94 399.77 315.46 401.23C316.97 402.68 319.48 402.51 321.33 401.53C323.18 400.55 324.59 398.93 326.18 397.56C334.16 390.68 404.49 372.75 475.37 346.53C477.65 345.69 481.96 344.73 481.13 342.92C480.46 341.83 479.1 342.32 477.52 342.87Z" fill="#F9F9FA"/> <path d="M617.32 297.99C614.17 298.96 617.37 300.28 617.47 300.33C642.79 312.07 667.46 324.73 691.6 338.44C693.63 339.59 696.12 338.08 696.04 335.75C695.77 328.44 691.71 315.3 685.81 295.67C682.07 283.25 681.77 281.37 674.22 281.74C668.92 281.99 634.66 292.7 617.32 297.99Z" fill="#222A27"/> <path d="M365.14 440.69C368.29 439.72 365.09 438.4 364.99 438.35C339.67 426.61 315 413.95 290.86 400.24C288.83 399.09 286.34 400.6 286.42 402.93C286.69 410.24 290.75 423.38 296.65 443.01C300.39 455.43 300.69 457.31 308.24 456.94C313.55 456.69 347.8 445.98 365.14 440.69Z" fill="#222A27"/> <path d="M414.95 359.86C394.54 365.15 374.16 371.16 354.22 378.02C381.42 391.34 409.07 403.73 437.11 415.18C439.17 416.02 441.27 416.87 443.49 416.98C445.76 417.1 447.99 416.44 450.17 415.79C469.61 410 489.05 404.2 508.48 398.41C476.84 386.18 445.61 373.4 414.95 359.86Z" fill="#232827"/> <path d="M542.58 320.76C523.27 325.78 504.63 331.76 485.78 338.2C484.75 338.55 484.67 339.98 485.64 340.45C511.95 353.26 538.18 364.96 565.31 376.04C567.37 376.88 569.47 377.73 571.69 377.84C573.96 377.96 576.19 377.3 578.37 376.65C596.68 371.19 614.98 365.74 633.29 360.28C634.4 359.95 634.46 358.41 633.38 357.99C603 346.19 572.85 333.81 543.38 320.81C543.12 320.71 542.84 320.69 542.58 320.76Z" fill="#242A27"/> <path d="M619.3 358.6C599.4 349.47 579.49 340.35 559.44 331.55C554.82 329.52 550.12 327.49 545.12 326.81C536.06 325.57 527.06 328.86 518.51 332.09C520.27 336.11 525.37 337.15 529.72 337.8C559.18 342.18 587.36 352.52 616.09 360.39C617 360.64 617.99 360.88 618.86 360.52C619.71 360.14 620.19 359.01 619.3 358.6Z" fill="black"/> <path d="M492.89 397.22C470.74 389.4 449.14 380.02 428.3 369.18C425.03 367.48 421.72 365.72 418.11 365.01C413.26 364.05 408.26 365.04 403.45 366.14C390.28 369.16 377.3 373.04 364.64 377.75C368.97 382.23 374.8 385.23 380.96 386.17C389.14 387.42 397.4 385.11 405.66 384.67C433.58 383.17 459.47 402.89 487.37 401C489.9 400.83 493.01 399.93 493.39 397.43C492.59 396.88 491.8 396.33 492.89 397.22Z" fill="black"/> <path d="M309.32 502.9C310.08 480.98 310.22 459.04 309.76 437.12C309.65 431.98 309.54 426.69 311.39 421.9C313.25 417.11 317.61 412.9 322.75 412.88C327.36 412.87 331.29 416.07 334.7 419.17C356.3 438.78 375.25 461.24 397.59 480C401.98 483.69 406.65 487.42 409.08 492.62C410.88 496.48 411.28 500.89 410.79 505.13C410.6 506.76 410.26 508.44 409.26 509.74C407.87 511.56 405.49 512.29 403.25 512.78C395.13 514.54 386.74 514.48 378.43 514.42C361.4 514.28 344.37 514.15 327.34 514.01C323.02 513.98 318.51 513.9 314.66 511.94C310.81 509.98 309.21 505.92 309.32 502.9Z" fill="#B9C2C9"/> <path d="M319.35 509.6C343.64 510.13 367.94 510.17 392.23 509.71C394.65 509.66 397.19 509.58 399.29 508.37C402.9 506.28 404.02 501.34 402.9 497.32C401.78 493.3 398.94 490.01 396.08 486.97C386.63 476.93 376.12 467.96 365.63 459.01C362.63 456.45 358.76 453.73 355.09 455.17C351.62 456.54 350.48 461.06 351.24 464.72C352 468.38 354.09 471.61 355.2 475.18C355.64 476.6 355.92 478.16 355.37 479.54C354.83 480.87 353.61 481.8 352.39 482.56C343.03 488.37 330.99 488.37 321.52 494.01C318.32 495.91 315.31 498.77 314.82 502.45C314.32 506.12 317.51 509.56 319.35 509.6Z" fill="#9CA4AD"/> <path d="M314.67 481.16C317.22 483.99 322.21 482.73 324.67 479.82C327.13 476.91 327.9 472.98 329.15 469.38C330.4 465.78 332.59 462.02 336.27 461.02C344.79 458.7 350.99 472.47 359.7 471.03C360.43 470.91 361.15 470.67 361.72 470.21C362.33 469.72 362.72 469.01 363.02 468.28C364.7 464.23 363.86 459.48 361.81 455.6C359.77 451.72 356.64 448.53 353.57 445.41C346.96 438.7 340.36 432 333.75 425.29C329.86 421.34 324.32 417.05 319.35 419.51C315.29 421.51 314.38 426.8 314.06 431.31C313.09 445.11 313.02 458.97 313.87 472.78C314.05 475.81 314.3 478.93 314.67 481.16Z" fill="#CDD1D6"/> <path d="M312.41 503.44C311.98 506.08 313.89 508.65 316.27 509.85C318.65 511.05 321.42 511.19 324.09 511.3C347.29 512.22 370.52 512.19 393.72 511.21C396.84 511.08 400.13 510.88 402.76 509.2C406.33 506.92 407.87 502.26 407.35 498.04C406.84 493.83 404.6 490.02 401.99 486.67C401.05 485.46 399.99 484.24 398.56 483.67C397.13 483.1 395.24 483.41 394.46 484.73C393.9 485.67 394.02 486.87 394.34 487.93C395.26 490.95 397.55 493.33 399.12 496.07C400.69 498.81 401.41 502.57 399.3 504.92C397.85 506.53 395.53 506.96 393.37 507.2C388.92 507.69 384.43 507.76 379.96 507.73C361.23 507.62 342.51 505.85 324.09 502.44C321.68 501.99 319.27 501.52 316.82 501.42C315.63 501.37 314.31 501.39 313.38 502.15C312.58 502.79 312.54 502.94 312.41 503.44Z" fill="#8F969C"/> <path d="M319.88 508.48C318.98 509.75 319.76 511.65 321.08 512.48C322.4 513.31 324.05 513.36 325.6 513.39C348.19 513.8 370.8 514.03 393.36 512.87C396.96 512.69 400.71 512.42 403.83 510.62C406.95 508.81 409.21 504.98 408.02 501.57C407.78 500.88 407.29 500.15 406.56 500.09C405.65 500.01 405.02 500.96 404.59 501.76C403.09 504.54 401.14 507.23 398.37 508.75C395.32 510.42 391.67 510.46 388.19 510.44C371.78 510.38 355.37 510.07 338.98 509.5C333.98 509.33 328.95 509.13 324.02 508.25C322.4 507.97 320.44 507.68 319.88 508.48Z" fill="#535B5D"/> <path d="M331.72 430.21C331.09 427.64 332.95 426.09 334.96 425.86C336.97 425.63 338.81 426.92 340.36 428.23C342.84 430.33 345.12 432.66 347.39 434.98C360.79 448.65 374.2 462.32 387.6 476C387.78 476.18 387.97 476.38 388 476.64C388.1 477.48 386.73 477.43 386.01 477C382.18 474.73 378.68 471.94 375.2 469.17C368.92 464.17 362.64 459.18 356.36 454.18C350.25 449.32 344.12 444.44 338.51 439.01C335.39 435.99 332.84 434.32 331.72 430.21Z" fill="#E5E7EA"/> <path d="M321.84 439.02C326.656 439.02 330.56 435.116 330.56 430.3C330.56 425.484 326.656 421.58 321.84 421.58C317.024 421.58 313.12 425.484 313.12 430.3C313.12 435.116 317.024 439.02 321.84 439.02Z" fill="#6D767A"/> <path d="M321.84 505.94C326.656 505.94 330.56 502.036 330.56 497.22C330.56 492.404 326.656 488.5 321.84 488.5C317.024 488.5 313.12 492.404 313.12 497.22C313.12 502.036 317.024 505.94 321.84 505.94Z" fill="#6D767A"/> <path d="M389.64 505.94C394.456 505.94 398.36 502.036 398.36 497.22C398.36 492.404 394.456 488.5 389.64 488.5C384.824 488.5 380.92 492.404 380.92 497.22C380.92 502.036 384.824 505.94 389.64 505.94Z" fill="#6D767A"/> <path d="M316.38 426.34C315.23 427.52 314.7 429.27 315 430.89C315.3 432.51 316.42 433.96 317.91 434.65C318.72 435.03 321.39 435.58 323.73 434.67C326.28 433.68 329.05 430.7 326.89 426.95C326.14 425.64 324.83 424.69 323.39 424.25C320.64 423.42 317.85 424.83 316.38 426.34Z" fill="#868D93"/> <path d="M324.22 491.58C323.08 490.59 321.4 490.13 319.84 490.39C318.28 490.65 316.89 491.61 316.22 492.91C315.86 493.61 315.32 495.92 316.2 497.95C317.15 500.16 320.02 502.55 323.63 500.69C324.89 500.04 325.8 498.91 326.23 497.66C327.03 495.26 325.67 492.85 324.22 491.58Z" fill="#868D93"/> <path d="M392.87 498.96C393.86 497.82 394.32 496.14 394.06 494.58C393.8 493.02 392.84 491.63 391.54 490.96C390.84 490.6 388.53 490.06 386.5 490.94C384.29 491.89 381.9 494.76 383.76 498.37C384.41 499.63 385.54 500.54 386.79 500.97C389.18 501.77 391.6 500.41 392.87 498.96Z" fill="#868D93"/> <path d="M319.05 436.61C320.7 437.1 322.52 437.02 324.1 436.34C325.68 435.66 327.01 434.39 327.72 432.83C328.04 432.13 328.24 431.38 328.41 430.63C328.47 430.34 328.54 430.05 328.72 429.81C328.9 429.58 329.23 429.44 329.49 429.57C329.78 429.72 329.84 430.11 329.84 430.44C329.83 432.47 329.03 434.48 327.65 435.97C326.27 437.46 324.32 438.4 322.3 438.56C321.26 438.64 320.19 438.52 319.25 438.07C319.01 437.96 318.77 437.82 318.61 437.6C318.45 437.39 318.39 437.08 318.53 436.85C318.66 436.62 319.01 436.53 319.05 436.61Z" fill="#535B5D"/> <path d="M319.05 436.61C320.7 437.1 322.52 437.02 324.1 436.34C325.68 435.66 327.01 434.39 327.72 432.83C328.04 432.13 328.24 431.38 328.41 430.63C328.47 430.34 328.54 430.05 328.72 429.81C328.9 429.58 329.23 429.44 329.49 429.57C329.78 429.72 329.84 430.11 329.84 430.44C329.83 432.47 329.03 434.48 327.65 435.97C326.27 437.46 324.32 438.4 322.3 438.56C321.26 438.64 320.19 438.52 319.25 438.07C319.01 437.96 318.77 437.82 318.61 437.6C318.45 437.39 318.39 437.08 318.53 436.85C318.66 436.62 319.01 436.53 319.05 436.61Z" fill="#535B5D"/> <path d="M319.05 502.93C320.7 503.42 322.52 503.34 324.1 502.66C325.68 501.98 327.01 500.71 327.72 499.15C328.04 498.45 328.24 497.7 328.41 496.95C328.47 496.66 328.54 496.37 328.72 496.13C328.9 495.9 329.23 495.76 329.49 495.89C329.78 496.04 329.84 496.43 329.84 496.76C329.83 498.79 329.03 500.8 327.65 502.29C326.27 503.78 324.32 504.72 322.3 504.88C321.26 504.96 320.19 504.84 319.25 504.39C319.01 504.28 318.77 504.14 318.61 503.92C318.45 503.7 318.39 503.4 318.53 503.17C318.66 502.93 319.01 502.84 319.05 502.93Z" fill="#535B5D"/> <path d="M386.98 502.93C388.63 503.42 390.45 503.34 392.03 502.66C393.61 501.98 394.94 500.71 395.65 499.15C395.97 498.45 396.17 497.7 396.34 496.95C396.4 496.66 396.47 496.37 396.65 496.13C396.83 495.9 397.16 495.76 397.42 495.89C397.71 496.04 397.77 496.43 397.77 496.76C397.76 498.79 396.96 500.8 395.58 502.29C394.2 503.78 392.25 504.72 390.23 504.88C389.19 504.96 388.12 504.84 387.18 504.39C386.94 504.28 386.7 504.14 386.54 503.92C386.38 503.7 386.32 503.4 386.46 503.17C386.59 502.93 386.94 502.84 386.98 502.93Z" fill="#535B5D"/> <path d="M317.21 427.8C316.89 428.55 316.84 429.36 316.79 430.18C316.64 432.67 319.7 433.29 319.7 431C319.7 428.03 321.99 428.14 322.8 428.26C323.94 428.44 325.05 427.74 323.87 426.32C322.44 424.62 318.18 425.49 317.21 427.8Z" fill="#A8AEB5"/> <path d="M317.21 427.8C316.89 428.55 316.84 429.36 316.79 430.18C316.64 432.67 319.7 433.29 319.7 431C319.7 428.03 321.99 428.14 322.8 428.26C323.94 428.44 325.05 427.74 323.87 426.32C322.44 424.62 318.18 425.49 317.21 427.8Z" fill="#A8AEB5"/> <path d="M317.21 493.46C316.89 494.21 316.84 495.02 316.79 495.84C316.64 498.33 319.7 498.95 319.7 496.66C319.7 493.69 321.99 493.8 322.8 493.92C323.94 494.1 325.05 493.4 323.87 491.98C322.44 490.28 318.18 491.15 317.21 493.46Z" fill="#A8AEB5"/> <path d="M385.02 493.46C384.7 494.21 384.65 495.02 384.6 495.84C384.45 498.33 387.51 498.95 387.51 496.66C387.51 493.69 389.8 493.8 390.61 493.92C391.75 494.1 392.86 493.4 391.68 491.98C390.25 490.28 385.99 491.15 385.02 493.46Z" fill="#A8AEB5"/> <path d="M314.22 447.54C314.2 446.42 313.03 444.95 312.13 447.1C310.22 451.66 311.78 470.13 312.51 487.52C312.56 488.72 312.5 490.7 313.84 490.31C314.76 490.13 314.5 488.59 314.49 487.65C314.4 474.29 314.31 460.93 314.22 447.56C314.22 447.56 314.22 447.55 314.22 447.54Z" fill="#535B5D"/> <path d="M661.55 582.27C593.3 582.27 525.07 581.2 456.82 581.41C423.91 581.51 390.91 582.9 358.1 581.72C330.29 580.72 338.59 589.53 344.7 589.38C453.7 586.42 560.08 584.11 669.08 587.1C669.44 587.11 669.86 586.97 670.04 586.83C670.03 586.83 675.86 582.27 661.55 582.27Z" fill="#E6E7EA"/> <path d="M665.11 625.88C556.11 628.84 481.74 628.84 380.82 628.16C380.46 628.16 339.34 627 339.34 630.81C339.34 630.81 338.08 632.99 348.24 632.99C416.49 632.99 484.72 634.06 552.97 633.85C585.88 633.75 618.88 632.36 651.69 633.54C679.52 634.54 670.15 625.69 665.11 625.88Z" fill="#E6E7EA"/> <path d="M347.06 674.45C345.47 674.46 343.93 674.29 342.35 674.2C338.75 674.01 337.27 675.06 336.88 676.04C335.89 678.56 346.02 678.96 349.17 678.95C449.14 678.73 652.85 680.67 661.6 678.63C661.6 678.63 669.13 677.85 668.16 675.63C667.2 673.43 658.98 673.55 656.31 673.59C557.81 674.97 375.36 674.29 347.06 674.45Z" fill="#E6E7EA"/> <path d="M551.83 677.49C551.69 686.06 551.56 694.63 551.42 703.2C551.4 704.45 551.39 705.73 551.82 706.89C552.25 708.06 553.23 709.11 554.47 709.25C555.86 709.41 557.16 708.37 557.76 707.11C558.36 705.85 558.42 704.41 558.46 703.02C558.71 694.7 558.87 686.39 558.93 678.07C558.93 677.85 558.92 677.62 558.78 677.46C558.6 677.27 558.3 677.27 558.04 677.29C555.92 677.46 553.8 677.63 551.83 677.49Z" fill="#E6E7EA"/> <path d="M442.18 677.5C442.89 683.32 442.73 689.25 441.72 695.02C440.95 699.43 439.78 704.37 442.33 708.05C442.99 709 443.97 709.84 445.13 709.87C446.32 709.9 447.38 709.03 447.93 707.98C448.47 706.92 448.58 705.7 448.64 704.52C448.97 696.86 447.55 685.87 449.3 678.41C449.61 677.1 449.63 678.74 448.76 677.71C448.36 677.23 447.75 676.97 447.14 676.81C445.37 676.35 443.43 676.66 442.18 677.5Z" fill="#E6E7EA"/> </svg>',
  };
  var stage = document.getElementById("deckStage");
  if (!stage) return;
  var cards = Array.prototype.slice.call(stage.querySelectorAll(".qc"));
  var CAT = "all",
    order = [],
    ptr = 0,
    anim = false,
    stack = [];
  function shuffle(a) {
    a = a.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i];
      a[i] = a[j];
      a[j] = t;
    }
    return a;
  }
  function pool() {
    return CAT === "all"
      ? CARDS
      : CARDS.filter(function (c) {
          return c[0] === CAT;
        });
  }
  function setFace(el, card) {
    el.classList.remove("t-question", "t-situation", "t-action");
    el.classList.add("t-" + card[0]);
    var f = el.querySelector(".qc-front");
    f.style.backgroundImage = "url('" + card[2] + "')";
    f.setAttribute("role", "img");
    f.setAttribute("aria-label", card[1]);
  }
  function build() {
    order = shuffle(pool());
    while (order.length < 3) {
      order = order.concat(order);
    }
    ptr = 0;
    for (var i = 0; i < 3; i++) {
      var el = cards[i];
      el.classList.remove("facedown", "out");
      el.style.transition = "none";
      el.style.transform = "";
      el.style.opacity = "";
      setFace(el, order[ptr]);
      el.setAttribute("data-pos", String(i));
      ptr = (ptr + 1) % order.length;
    }
    stack = [cards[0], cards[1], cards[2]];
    void stage.offsetWidth;
    for (var k = 0; k < 3; k++) cards[k].style.transition = "";
    stack[0].classList.add("facedown");
  }
  function relayer() {
    for (var i = 0; i < 3; i++) stack[i].setAttribute("data-pos", String(i));
  }
  function advance(dir) {
    if (anim) return;
    anim = true;
    stopNudge();
    var front = stack[0];
    front.classList.add("out");
    front.style.transform =
      "translateX(" + dir * 460 + "px) translateY(70px) rotate(" + dir * 20 + "deg)";
    front.style.opacity = "0";
    setTimeout(function () {
      front.style.transition = "none";
      front.classList.remove("facedown", "out");
      setFace(front, order[ptr]);
      ptr = (ptr + 1) % order.length;
      front.style.transform = "";
      front.style.opacity = "";
      stack = [stack[1], stack[2], front];
      relayer();
      void front.offsetWidth;
      front.style.transition = "";
      anim = false;
    }, 430);
  }
  var chipWrap = document.getElementById("chips");
  if (chipWrap) {
    chipWrap.querySelectorAll(".chip").forEach(function (b) {
      b.addEventListener("click", function () {
        chipWrap.querySelectorAll(".chip").forEach(function (x) {
          x.classList.remove("sel");
        });
        b.classList.add("sel");
        CAT = b.dataset.cat;
        build();
      });
    });
  }
  var db = document.getElementById("drawbtn");
  if (db)
    db.addEventListener("click", function () {
      advance(Math.random() < 0.5 ? -1 : 1);
    });
  /* nudge the top card whenever the section is in view, until the user swipes */
  var nudgeDone = false;
  function pauseNudge() {
    cards.forEach(function (c) {
      c.classList.remove("nudge");
    });
  }
  function stopNudge() {
    nudgeDone = true;
    pauseNudge();
  }
  if ("IntersectionObserver" in window) {
    var nio = new IntersectionObserver(
      function (en) {
        if (nudgeDone) {
          nio.disconnect();
          return;
        }
        if (en[0].isIntersecting) stack[0].classList.add("nudge");
        else pauseNudge();
      },
      { threshold: 0.6 },
    );
    nio.observe(stage);
  }
  var sx = 0,
    dragging = false,
    moved = false;
  stage.addEventListener("pointerdown", function (e) {
    if (anim) return;
    var top = stack[0];
    if (!e.target.closest(".qc") || e.target.closest(".qc") !== top) return;
    /* pause (not stop) so a scroll-touch never kills the hint */
    pauseNudge();
    dragging = true;
    moved = false;
    sx = e.clientX;
    top.style.transition = "none";
    try {
      top.setPointerCapture(e.pointerId);
    } catch (_) {}
  });
  stage.addEventListener("pointermove", function (e) {
    if (!dragging) return;
    var top = stack[0];
    var dx = e.clientX - sx;
    if (Math.abs(dx) > 5) moved = true;
    top.style.transform = "translateX(" + dx + "px) rotate(" + dx / 24 + "deg)";
  });
  stage.addEventListener("pointerup", function (e) {
    if (!dragging) return;
    dragging = false;
    var top = stack[0];
    var dx = e.clientX - sx;
    top.style.transition = "";
    if (Math.abs(dx) > 80) {
      advance(dx > 0 ? 1 : -1);
    } else {
      top.style.transform = "";
      if (!moved) {
        if (top.classList.contains("facedown")) {
          top.classList.remove("facedown");
          if (!nudgeDone) top.classList.add("nudge");
        } else advance(Math.random() < 0.5 ? -1 : 1);
      } else if (!nudgeDone) {
        top.classList.add("nudge");
      }
    }
  });
  build();
})();
var DISC = 1;
/* format in the visitor's presentment currency (ZC.currency, per market) */
function money(n) {
  var v = Math.round(n * 100) / 100;
  var cur = (window.ZC && ZC.currency) || "GBP";
  var opts = {
    style: "currency",
    currency: cur,
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: v % 1 !== 0 ? 2 : 0,
    maximumFractionDigits: 2,
  };
  try {
    return new Intl.NumberFormat(undefined, opts).format(v);
  } catch (e) {
    try {
      delete opts.currencyDisplay;
      return new Intl.NumberFormat(undefined, opts).format(v);
    } catch (e2) {
      return "£" + v.toFixed(2);
    }
  }
}
window.__zcMoney = money;
/* any element with data-cents shows the welcome-discount preview price */
window.__zcPreviewPrices = function () {
  var d = window.__disc || 1;
  if (d >= 1) return;
  document.querySelectorAll("[data-cents]").forEach(function (el) {
    var c = +el.getAttribute("data-cents");
    if (c) el.innerHTML = "<s>" + money(c / 100) + "</s> " + money((c / 100) * d);
  });
  if (window.__zcHomeOffer) window.__zcHomeOffer();
};
window.__renderOffer = function () {
  var sel = document.querySelector(".opt.pk.sel") || document.querySelector(".opt.pk");
  if (!sel) return;
  var base = window.ZC && ZC.product && ZC.product.unit ? ZC.product.unit / 100 : 34;
  var welcome = DISC < 1 ? Math.round((1 - DISC) * 100) : 0;
  // Single source of truth: every pack computes from base price + the larger of
  // its multibuy % and the active welcome %. One discount applies, never both.
  document.querySelectorAll(".opt.pk").forEach(function (o) {
    var q = +o.dataset.qty || 1,
      m = +o.dataset.off || 0,
      off = Math.max(m, welcome);
    var list = base * q,
      total = list * (1 - off / 100);
    var tot = o.querySelector(".pk-tot");
    if (tot)
      tot.innerHTML =
        (off > 0 ? '<span class="was">' + money(list) + "</span>" : "") + money(total);
    var per = o.querySelector(".pk-per");
    if (per) per.textContent = money(total / q) + "/box";
    var sb = o.querySelector(".pk-saveb");
    if (sb) {
      sb.textContent = off > 0 ? "Save " + off + "%" : "";
      sb.style.display = off > 0 ? "" : "none";
    }
  });
  var q = +sel.dataset.qty || 1,
    m = +sel.dataset.off || 0,
    off = Math.max(m, welcome);
  var total = base * q * (1 - off / 100);
  var noun = q > 1 ? q + " boxes" : "1 box";
  var cta = document.getElementById("offerCta");
  if (cta) cta.textContent = "Add " + noun + " to cart \u00b7 " + money(total);
  if (window.__syncSticky) window.__syncSticky();
  var cn = document.getElementById("codeNote");
  if (cn) {
    if (welcome > 0) cn.innerHTML = "\u2713 " + welcome + "% welcome discount applied at checkout";
    else if (m > 0) cn.innerHTML = "\u2713 " + m + "% multibuy saving applied in your basket";
    else cn.innerHTML = "Add 2 or more boxes to unlock multibuy savings.";
  }
};
// SEAM: capture a lead into the marketing list. Shopify customer form today
// (no API keys); swap the body when the lead destination changes. Shopify's
// spam protection can intercept scripted posts with a /challenge page and drop
// the lead, so the response is checked and drops are logged, never silent.
// Tags drive email segmentation.
window.captureLead = function (data) {
  if (!data || !data.email) return Promise.resolve();
  var body = new URLSearchParams();
  body.set("form_type", "customer");
  body.set("utf8", "✓");
  body.set("contact[email]", data.email);
  body.set("contact[accepts_marketing]", "true");
  if (data.name) body.set("contact[first_name]", data.name);
  if (data.phone) body.set("contact[phone]", data.phone);
  if (data.tags) body.set("contact[tags]", data.tags);
  return fetch("/contact", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: body.toString(),
  })
    .then(function (r) {
      if (!r.ok || r.url.indexOf("/challenge") !== -1)
        console.warn("captureLead: Shopify dropped the lead (spam challenge)");
    })
    .catch(function () {});
};
window.__applyDiscount = function (m) {
  DISC = m || 0.9;
  window.__disc = DISC;
  window.__welcomeCode = m && m <= 0.85 ? window.ZC.codes.welcome15 : window.ZC.codes.welcome10;
  window.__renderOffer();
  window.__zcPreviewPrices();
  var db = document.getElementById("discBar");
  if (db) {
    db.hidden = false;
    db.textContent =
      "\u2713 Your " +
      Math.round((1 - DISC) * 100) +
      "% welcome discount is applied to every price";
  }
  try {
    localStorage.setItem("zc_disc", String(DISC));
  } catch (e) {}
};
window.__applyName = function (n) {
  n = (n || "").trim();
  if (!n) return;
  n = n.charAt(0).toUpperCase() + n.slice(1).toLowerCase();
  window.__name = n;
  var ev = document.getElementById("rewardEmail");
  window.__buyer = { name: n, email: ev ? ev.value : "" };
  var ot = document.getElementById("offerTitle");
  if (ot)
    ot.innerHTML =
      'The Marriage Meeting<sup class="tm">®</sup>, for you, <span class="hl-name">' +
      n +
      "</span>";
  var bar = document.getElementById("resbar"),
    rl = bar ? bar.querySelector(".rl") : null;
  if (rl && bar.classList.contains("show"))
    rl.innerHTML = '🔒 Reserved for <span class="hl-name">' + n + "</span>";
};
document.querySelectorAll(".opt.pk").forEach(function (o) {
  o.addEventListener("click", function () {
    document.querySelectorAll(".opt.pk").forEach(function (x) {
      x.classList.remove("sel");
    });
    o.classList.add("sel");
    window.__renderOffer();
  });
});
window.__renderOffer();
function countUp(el) {
  const t = +el.dataset.to,
    suf = el.dataset.suf || "",
    dur = 1400;
  let s = null;
  function step(ts) {
    if (!s) s = ts;
    const p = Math.min((ts - s) / dur, 1),
      v = Math.floor(p * t);
    el.textContent = (t >= 1000 ? v.toLocaleString() : v) + suf;
    if (p < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}
const cio = new IntersectionObserver(
  (es) => {
    es.forEach((e) => {
      if (e.isIntersecting) {
        countUp(e.target);
        cio.unobserve(e.target);
      }
    });
  },
  { threshold: 0.5 },
);
document.querySelectorAll(".cnum").forEach((el) => cio.observe(el));
const TOASTS = []; /* TODO: feed real ship locations from Shopify */
const toast = document.getElementById("toast");
let ti = 0;
function showToast() {
  if (!toast || !TOASTS.length) return;
  toast.querySelector(".tx").textContent = "Just shipped to " + TOASTS[ti % TOASTS.length];
  ti++;
  toast.classList.add("show");
  setTimeout(() => toast.classList.remove("show"), 2600);
}
const mapsec = document.getElementById("mapsec");
if (mapsec) {
  const mio = new IntersectionObserver(
    (es) => {
      es.forEach((e) => {
        if (e.isIntersecting) {
          showToast();
          setInterval(showToast, 3600);
          mio.unobserve(e.target);
        }
      });
    },
    { threshold: 0.3 },
  );
  mio.observe(mapsec);
}
var BAR = [
  "\u2605 Rated 4.9 from 100+ reviews",
  "5,000+ boxes shipped to 50+ countries",
  "The most thoughtful pre-marriage gift",
];
var bm = document.getElementById("barmsg"),
  bi = 0;
if (bm) {
  setInterval(function () {
    bm.style.opacity = 0;
    setTimeout(function () {
      bi = (bi + 1) % BAR.length;
      bm.textContent = BAR[bi];
      bm.style.opacity = 1;
    }, 400);
  }, 3800);
}
var cr = document.getElementById("calcRange");
if (cr) {
  var ca = document.getElementById("calcAmt"),
    cy = document.getElementById("calcYears");
  function updc() {
    var y = +cr.value,
      pct = ((y - 1) / 39) * 100;
    ca.textContent = "\u00a3" + (y * 30000).toLocaleString();
    cy.textContent = y + (y === 1 ? " year" : " years");
    cr.style.background =
      "linear-gradient(to right,var(--citron) " + pct + "%,rgba(255,255,255,.28) " + pct + "%)";
  }
  cr.addEventListener("input", updc);
  updc();
}
(function () {
  var modal = document.getElementById("rewardModal"),
    card = document.getElementById("rewardCard"),
    cv = document.getElementById("scratchCanvas"),
    scr = document.getElementById("scratch"),
    bubble = document.getElementById("rewardBubble");
  var shown = false,
    ctx,
    drawing = false,
    revealed = false;
  if (!modal) return; /* pages like free-guide render without the popup */
  function open() {
    shown = true;
    modal.classList.add("show");
    if (bubble) bubble.classList.remove("show");
    if (!revealed) setup();
  }
  function isClaimed() {
    try {
      return !!localStorage.getItem("zc_email") || parseFloat(localStorage.getItem("zc_disc")) < 1;
    } catch (e) {
      return false;
    }
  }
  /* closing never kills the offer: unclaimed visitors keep a floating bubble */
  function close() {
    modal.classList.remove("show");
    if (!isClaimed() && bubble) {
      bubble.classList.add("show");
      try {
        localStorage.setItem("zc_popup_dismissed", "1");
      } catch (e) {}
    }
  }
  document.getElementById("rewardClose").addEventListener("click", close);
  modal.addEventListener("click", function (e) {
    if (e.target === modal) close();
  });
  if (bubble) bubble.addEventListener("click", open);
  function setup() {
    if (!cv) return;
    var r = cv.getBoundingClientRect();
    cv.width = r.width;
    cv.height = r.height;
    ctx = cv.getContext("2d");
    ctx.fillStyle = "#E8DC5B";
    ctx.fillRect(0, 0, cv.width, cv.height);
    ctx.fillStyle = "rgba(0,0,0,.06)";
    for (var i = 0; i < 170; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * cv.width, Math.random() * cv.height, 1.2, 0, 7);
      ctx.fill();
    }
    ctx.fillStyle = "#241B14";
    ctx.font = "700 17px 'Neulis Neue',sans-serif";
    ctx.textAlign = "center";
    ctx.fillText("SCRATCH HERE", cv.width / 2, cv.height / 2 + 5);
    ctx.globalCompositeOperation = "destination-out";
  }
  function pos(e) {
    var r = cv.getBoundingClientRect();
    var t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - r.left, y: t.clientY - r.top };
  }
  function scratch(e) {
    if (!drawing) return;
    var p = pos(e);
    ctx.beginPath();
    ctx.arc(p.x, p.y, 26, 0, 7);
    ctx.fill();
  }
  function check() {
    try {
      var d = ctx.getImageData(0, 0, cv.width, cv.height).data,
        clear = 0,
        tot = 0;
      for (var i = 3; i < d.length; i += 160) {
        tot++;
        if (d[i] === 0) clear++;
      }
      if (clear / tot > 0.08 && !revealed) {
        revealed = true;
        scr.classList.add("done");
        card.classList.add("revealed");
      }
    } catch (err) {}
  }
  if (cv) {
    cv.addEventListener("pointerdown", function (e) {
      drawing = true;
      scratch(e);
    });
    cv.addEventListener("pointermove", scratch);
  }
  window.addEventListener("pointerup", function () {
    if (drawing) {
      drawing = false;
      check();
    }
  });
  document.getElementById("rewardClaim").addEventListener("click", function () {
    var em = document.getElementById("rewardEmail").value,
      nm = (document.getElementById("rewardName") || {}).value;
    if (em) {
      try {
        localStorage.setItem("zc_email", em);
        if (nm) localStorage.setItem("zc_name", nm);
      } catch (e) {}
      if (window.captureLead) window.captureLead({ email: em, name: nm, tags: "welcome-popup" });
      if (window.__applyName) window.__applyName(nm);
      if (window.__applyDiscount) window.__applyDiscount(0.9);
      var s1 = document.getElementById("rcStep1"),
        s2 = document.getElementById("rcStep2");
      if (s1 && s2) {
        s1.hidden = true;
        s2.hidden = false;
      } else {
        var ov = document.getElementById("rewardModal");
        if (ov) ov.classList.remove("show");
      }
    }
  });
  (function () {
    var nm = document.getElementById("rewardName");
    if (nm && nm.closest) {
      var c = nm.closest(".claim");
      if (c) {
        nm.addEventListener("input", function () {
          if (nm.value.trim()) c.classList.add("named");
        });
      }
    }
  })();
  /* one popup for the whole store: never auto-reopen once claimed.
     Dismissed-but-unclaimed visitors get the bubble instead of a re-popup. */
  if (!isClaimed()) {
    var dismissed = false;
    try {
      dismissed = !!localStorage.getItem("zc_popup_dismissed");
    } catch (e) {}
    if (dismissed && bubble) bubble.classList.add("show");
    else setTimeout(open, 3000);
  }
})();
(function () {
  var pop = document.getElementById("salepop");
  if (!pop) return;
  var N = [];
  /* TODO: feed real recent orders from Shopify */ var i = 0;
  function show() {
    if (!N.length) return;
    var n = N[i % N.length];
    i++;
    document.getElementById("saleAv").textContent = n[0][0];
    document.getElementById("saleName").textContent = n[0] + " in " + n[1];
    document.getElementById("saleTime").textContent =
      Math.floor(Math.random() * 28) + 2 + " minutes ago";
    pop.classList.add("show");
    document.body.classList.add("sale-on");
    setTimeout(function () {
      pop.classList.remove("show");
      document.body.classList.remove("sale-on");
    }, 5000);
  }
  setTimeout(function () {
    show();
    setInterval(show, 13000);
  }, 4000);
})();
window.__startReserve = function () {
  return;
  /* fake countdown disabled — wire to real held stock if used */ var bar =
      document.getElementById("resbar"),
    rt = document.getElementById("resTime"),
    rl = bar ? bar.querySelector(".rl") : null,
    rr = bar ? bar.querySelector(".rr") : null;
  if (!bar || bar.classList.contains("show")) return;
  document.body.classList.add("reserving");
  if (rr) rr.textContent = "left to check out";
  bar.classList.add("show");
  if (rl)
    rl.innerHTML = window.__name
      ? '🔒 Reserved for <span class="hl-name">' + window.__name + "</span>"
      : "🔒 We reserved your box";
  var left = 600;
  function tick() {
    var m = Math.floor(left / 60),
      sc = left % 60;
    rt.textContent = m + ":" + (sc < 10 ? "0" : "") + sc;
    var ctd = document.getElementById("cdTime");
    if (ctd) ctd.textContent = m + ":" + (sc < 10 ? "0" : "") + sc;
    if (left <= 0) {
      clearInterval(iv);
      if (rl) rl.textContent = "Reservation expired";
      rt.textContent = "";
      if (rr) rr.textContent = "";
      setTimeout(function () {
        bar.classList.remove("show");
        document.body.classList.remove("reserving");
      }, 4000);
    }
    left--;
  }
  var iv = setInterval(tick, 1000);
  tick();
};
(function () {
  var oc = document.getElementById("offerCta");
  if (oc)
    oc.addEventListener("click", function () {
      var sel = document.querySelector(".opt.pk.sel"),
        q = sel ? +sel.dataset.qty || 1 : 1;
      window.__addToCart && window.__addToCart("box", q);
    });
})();
/* hide the "Swipe" hint when the collection row has nothing to scroll */
(function () {
  var row = document.querySelector(".qrow"),
    hint = document.querySelector(".qshop-head .qhint");
  if (!row || !hint) return;
  function upd() {
    hint.style.display = row.scrollWidth > row.clientWidth + 4 ? "" : "none";
  }
  window.addEventListener("resize", upd);
  upd();
})();
/* delegated so collection-card Add buttons always work, whatever the load order */
document.addEventListener("click", function (e) {
  var b = e.target.closest ? e.target.closest("button.qadd") : null;
  if (!b) return;
  e.preventDefault();
  if (b.dataset.variant) {
    window.__addVariant && window.__addVariant(b.dataset.variant);
  } else {
    var card = b.closest(".qcard"),
      nm = card ? card.querySelector(".qn").textContent : "";
    var map = {
      "The Box + App": "bundle",
      "The Marriage Meeting Box": "box",
      "App access": "app",
      "10 Steps to Get Married": "book",
      "Wedding Card Generator": "invite",
    };
    var key = map[nm];
    if (key && window.__addToCart) window.__addToCart(key);
  }
  var t0 = b.textContent;
  if (t0 !== "Added ✓") {
    b.textContent = "Added ✓";
    setTimeout(function () {
      b.textContent = t0;
    }, 1200);
  }
});
document.querySelectorAll(".gthumb").forEach(function (t) {
  t.addEventListener("click", function () {
    var m = document.getElementById("gmain"),
      im = t.querySelector("img");
    if (m && im) m.src = im.src;
    document.querySelectorAll(".gthumb").forEach(function (x) {
      x.classList.remove("active");
    });
    t.classList.add("active");
  });
});
(function () {
  var bd = document.getElementById("cartBd"),
    dr = document.getElementById("cartDrawer");
  if (!bd || !dr) return;
  var ZCV = (window.ZC && window.ZC.variants) || {};
  var COUNTRY = (window.ZC && window.ZC.country) || "";
  var FS = (window.ZC && window.ZC.freeShip) || { uk: 50, intl: 100 };
  var state = null,
    busy = false;
  function money(cents) {
    return window.__zcMoney((cents || 0) / 100);
  }
  function threshold() {
    return (COUNTRY === "GB" ? FS.uk : FS.intl) * 100;
  }
  function sized(url) {
    if (!url) return "";
    return url.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, "_120x$1$2");
  }
  function openC() {
    bd.classList.add("show");
    dr.classList.add("show");
  }
  function closeC() {
    bd.classList.remove("show");
    dr.classList.remove("show");
  }
  function setDot() {
    var d = document.querySelector(".cart .dot");
    if (d) d.textContent = state ? state.item_count : 0;
  }
  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        state = c;
        return c;
      });
  }
  function discountTitle() {
    if (!state) return "Discount";
    var a = state.cart_level_discount_applications;
    if (a && a[0] && a[0].title) return a[0].title;
    var items = state.items || [];
    for (var i = 0; i < items.length; i++) {
      var d = items[i].discounts;
      if (d && d[0] && d[0].title) return d[0].title;
    }
    return "Discount";
  }
  function itemRow(item, codeMult) {
    var img = item.image
      ? '<img class="ci-img" src="' + sized(item.image) + '" alt="">'
      : '<div class="ci-img ci-ph">' +
        (item.product_title ? item.product_title.charAt(0) : "?") +
        "</div>";
    var sub =
      item.variant_title && item.variant_title !== "Default Title"
        ? " <small>" + item.variant_title + "</small>"
        : "";
    /* the welcome code replaces line-level automatic discounts at checkout,
       so when it wins the line shows original struck + code price instead */
    var was = 0,
      now = item.final_line_price;
    if (codeMult < 1) {
      was = item.original_line_price;
      now = Math.round(item.original_line_price * codeMult);
    } else if (item.original_line_price > item.final_line_price) {
      was = item.original_line_price;
    }
    var price = "";
    if (was > now) price += '<span class="ci-was">' + money(was) + "</span> ";
    price += money(now);
    return (
      '<div class="cd-item">' +
      img +
      '<div class="ci-n">' +
      item.product_title +
      sub +
      "</div>" +
      '<div class="cd-qty"><button data-dec="' +
      item.key +
      '">−</button><span>' +
      item.quantity +
      '</span><button data-inc="' +
      item.key +
      '">+</button></div>' +
      '<button class="ci-rm" data-rm="' +
      item.key +
      '">Remove</button>' +
      '<div class="ci-p">' +
      price +
      "</div>" +
      "</div>"
    );
  }
  function render() {
    /* decide up front whether the unlocked welcome CODE beats the automatic
       discount — Shopify won't combine them at checkout, the code replaces */
    var td = state ? state.total_discounts : 0;
    var orig = state ? state.original_total_price : 0;
    var d = window.__disc || 1;
    var wAmt = 0;
    if (state && state.item_count > 0 && window.__welcomeCode && d < 1) {
      wAmt = Math.round(orig * (1 - d));
      if (wAmt <= td) wAmt = 0;
    }
    window.__codeWins = wAmt > 0;
    var codeMult = wAmt > 0 ? d : 1;
    var items = state && state.items ? state.items : [];
    var html = "";
    for (var i = 0; i < items.length; i++) html += itemRow(items[i], codeMult);
    if (!html) html = '<div class="cd-empty">Your basket is empty</div>';
    var ci = document.getElementById("cdItems");
    if (ci) ci.innerHTML = html;
    var sub = state ? state.items_subtotal_price : 0;
    var th = threshold();
    /* thresholds are set in GBP; in other presentment currencies the cart
       totals are converted, so the comparison would lie — hide the bar */
    var fsOk = ((window.ZC && ZC.currency) || "GBP") === "GBP";
    var met = fsOk && sub >= th;
    var g = document.getElementById("cdGift");
    if (g) {
      if (!state || state.item_count <= 0 || !fsOk) {
        g.style.display = "none";
      } else {
        g.style.display = "block";
        g.className = "cdbar";
        var head = met
          ? "🎉 You've unlocked free shipping"
          : "Add " + money(th - sub) + " more for free shipping";
        var pct = th > 0 ? Math.min(100, (sub / th) * 100) : 0;
        g.innerHTML =
          '<div class="cdbar-head' +
          (met ? " alldone" : "") +
          '">' +
          head +
          "</div>" +
          '<div class="cdbar-track"><div class="cdbar-fill" style="width:' +
          pct +
          '%"></div></div>';
      }
    }
    var subEl = document.getElementById("cdSub");
    if (subEl) subEl.textContent = money(sub);
    var dl = document.getElementById("cdDiscLine");
    if (dl) {
      if (td > 0 && wAmt === 0) {
        dl.style.display = "flex";
        dl.querySelector("span:first-child").textContent = discountTitle();
        dl.querySelector("span:last-child").textContent = "−" + money(td);
      } else dl.style.display = "none";
    }
    var wl = document.getElementById("cdWelcomeLine");
    if (wl) {
      if (wAmt > 0) {
        wl.style.display = "flex";
        wl.querySelector("span:first-child").textContent =
          Math.round((1 - d) * 100) + "% welcome code (at checkout)";
        wl.querySelector("span:last-child").textContent = "−" + money(wAmt);
      } else wl.style.display = "none";
    }
    var sl = document.getElementById("cdShipLine");
    if (sl) {
      if (state && state.item_count > 0) {
        sl.style.display = "flex";
        var se = document.getElementById("cdShip");
        if (se) {
          if (met) {
            se.textContent = "FREE";
            se.className = "free";
          } else {
            se.textContent = "Calculated at checkout";
            se.className = "";
          }
        }
      } else sl.style.display = "none";
    }
    var tot = document.getElementById("cdTotal");
    if (tot)
      tot.textContent = money(wAmt > 0 ? Math.max(0, orig - wAmt) : state ? state.total_price : 0);
    setDot();
    syncUpsell();
  }
  function syncUpsell() {
    var wrap = document.getElementById("cdUpsell");
    if (!wrap) return;
    var inCart = {};
    if (state && state.items)
      state.items.forEach(function (i) {
        inCart[i.variant_id] = true;
      });
    var visible = 0;
    wrap.querySelectorAll(".cd-up-item").forEach(function (el) {
      var hide = inCart[+el.getAttribute("data-variant")];
      el.style.display = hide ? "none" : "";
      if (!hide) visible++;
    });
    wrap.hidden = visible === 0;
  }
  function changeCart(key, quantity) {
    if (busy) return;
    busy = true;
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        state = c;
        render();
      })
      .catch(function () {})
      .then(function () {
        busy = false;
      });
  }
  window.__addToCart = function (key, qty) {
    var id = ZCV[key];
    if (!id) return Promise.resolve();
    if (busy) return Promise.resolve();
    busy = true;
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] }),
    })
      .then(function () {
        return getCart();
      })
      .then(function () {
        render();
        openC();
      })
      .catch(function () {})
      .then(function () {
        busy = false;
      });
  };
  window.__openCart = openC;
  window.__addVariant = function (id, qty) {
    if (!id || busy) return Promise.resolve();
    busy = true;
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: +id, quantity: qty || 1 }] }),
    })
      .then(function () {
        return getCart();
      })
      .then(function () {
        render();
        openC();
      })
      .catch(function () {})
      .then(function () {
        busy = false;
      });
  };
  dr.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.dataset) return;
    var items = state && state.items ? state.items : [];
    function find(k) {
      for (var i = 0; i < items.length; i++) if (items[i].key === k) return items[i];
      return null;
    }
    if (t.dataset.dec) {
      var a = find(t.dataset.dec);
      if (a) changeCart(a.key, a.quantity - 1);
    } else if (t.dataset.inc) {
      var b = find(t.dataset.inc);
      if (b) changeCart(b.key, b.quantity + 1);
    } else if (t.dataset.rm) {
      changeCart(t.dataset.rm, 0);
    } else if (t.classList && t.classList.contains("cd-up-add")) {
      window.__addVariant(t.getAttribute("data-variant"));
    } else if (t.classList && t.classList.contains("cd-gift-add")) {
      if (window.ZC && ZC.variants && ZC.variants.box) {
        var gr = t.getBoundingClientRect();
        zcConfetti(gr.left + gr.width / 2, gr.top + gr.height / 2);
        var gorig = t.getAttribute("data-label") || t.textContent;
        t.setAttribute("data-label", gorig);
        t.textContent = "Added \u2713";
        t.classList.add("added");
        setTimeout(function () {
          t.textContent = gorig;
          t.classList.remove("added");
        }, 1600);
        window.__addVariant(ZC.variants.box);
      }
    }
  });
  var cc = document.getElementById("cartClose");
  if (cc) cc.addEventListener("click", closeC);
  bd.addEventListener("click", closeC);
  var cl = document.querySelector(".cart");
  if (cl)
    cl.addEventListener("click", function (e) {
      e.preventDefault();
      getCart()
        .then(function () {
          render();
          openC();
        })
        .catch(function () {
          openC();
        });
    });
  var co = document.querySelector(".cd-checkout");
  if (co)
    co.addEventListener("click", function () {
      var p = new URLSearchParams();
      /* only carry the code when it beats the automatic discount — Shopify
         replaces a non-combinable automatic with the entered code */
      if (window.__welcomeCode && window.__codeWins) p.set("discount", window.__welcomeCode);
      var em = "",
        nm = "",
        phn = "";
      try {
        em = localStorage.getItem("zc_email") || "";
        nm = localStorage.getItem("zc_name") || "";
        phn = localStorage.getItem("zc_phone") || "";
      } catch (e) {}
      if (nm) p.set("checkout[shipping_address][first_name]", nm);
      if (phn) p.set("checkout[shipping_address][phone]", phn);
      /* email prefill is only honored on cart permalinks; a permalink
         rebuilds the cart, so never use it when a line carries properties
         (e.g. gift-card recipient details) */
      var items = state && state.items ? state.items : [];
      var plain =
        items.length > 0 &&
        items.every(function (i) {
          return !i.properties || Object.keys(i.properties).length === 0;
        });
      if (em && plain) {
        p.set("checkout[email]", em);
        var path = items
          .map(function (i) {
            return i.variant_id + ":" + i.quantity;
          })
          .join(",");
        window.location.href = "/cart/" + path + "?" + p.toString();
        return;
      }
      var q = p.toString();
      window.location.href = "/checkout" + (q ? "?" + q : "");
    });
  getCart().then(render).catch(render);
})();
(function () {
  function off() {
    var tb = document.querySelector(".topbar");
    return (tb ? tb.offsetHeight : 62) + 10;
  }
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    if (a.classList.contains("cart")) return;
    a.addEventListener("click", function (e) {
      var id = a.getAttribute("href");
      if (!id || id === "#") return;
      var el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      var y = el.getBoundingClientRect().top + window.pageYOffset - off();
      window.scrollTo({ top: y, behavior: "smooth" });
    });
  });
})();
(function () {
  var bar = document.getElementById("pdpSticky"),
    btn = document.getElementById("pdpStickyAdd"),
    sel = document.getElementById("psSelect"),
    menu = document.getElementById("psMenu"),
    h = document.getElementById("offer");
  if (!bar || !btn || !h) return;
  var tiles = [].slice.call(document.querySelectorAll(".opt.pk"));
  var PNAME = (window.ZC && ZC.product && ZC.product.title) || "The Marriage Meeting";
  function fmtP(p) {
    return window.__zcMoney(p);
  }
  function td(t) {
    var q = +t.dataset.qty || 1;
    var multibuy = +t.dataset.off || 0;
    var base = window.ZC && ZC.product && ZC.product.unit ? ZC.product.unit / 100 : 34;
    var welcome = window.__disc && window.__disc < 1 ? Math.round((1 - window.__disc) * 100) : 0;
    var off = Math.max(multibuy, welcome); // one discount applies, the larger
    var total = base * q * (1 - off / 100);
    return {
      qty: q,
      off: off,
      price: total,
      name: PNAME + " \u00d7 " + q,
      per: fmtP(total / q) + "/box",
    };
  }
  function selected() {
    return document.querySelector(".opt.pk.sel") || tiles[0];
  }
  if (menu && tiles.length) {
    menu.innerHTML = tiles
      .map(function (t, i) {
        var d = td(t);
        return (
          '<button type="button" class="ps-opt" data-i="' +
          i +
          '">' +
          '<span class="ps-opt-name">' +
          d.name +
          (d.off > 0 ? ' <span class="ps-save">Save ' + d.off + "%</span>" : "") +
          "</span>" +
          '<span class="ps-opt-sub">' +
          d.per +
          "</span></button>"
        );
      })
      .join("");
    menu.addEventListener("click", function (e) {
      var b = e.target.closest(".ps-opt");
      if (!b) return;
      var t = tiles[+b.dataset.i];
      tiles.forEach(function (x) {
        x.classList.remove("sel");
      });
      t.classList.add("sel");
      if (window.__renderOffer) window.__renderOffer();
      closeMenu();
    });
  }
  function openMenu() {
    if (menu) {
      menu.hidden = false;
      sel.setAttribute("aria-expanded", "true");
    }
  }
  function closeMenu() {
    if (menu) {
      menu.hidden = true;
      sel.setAttribute("aria-expanded", "false");
    }
  }
  if (sel)
    sel.addEventListener("click", function (e) {
      e.stopPropagation();
      menu.hidden ? openMenu() : closeMenu();
    });
  document.addEventListener("click", function (e) {
    if (menu && !menu.hidden && !bar.contains(e.target)) closeMenu();
  });
  window.__syncSticky = function () {
    var t = selected();
    if (!t) return;
    var d = td(t);
    var n = document.getElementById("psName");
    if (n) n.textContent = d.name;
    var s = document.getElementById("psSave");
    if (s) {
      if (d.off > 0) {
        s.textContent = "Save " + d.off + "%";
        s.style.display = "";
      } else s.style.display = "none";
    }
    var sub = document.getElementById("psSub");
    if (sub) sub.textContent = d.per;
    var ap = document.getElementById("psAddPrice");
    if (ap) ap.textContent = " \u00b7 " + fmtP(d.price);
    if (menu)
      [].forEach.call(menu.querySelectorAll(".ps-opt"), function (o, i) {
        o.classList.toggle("active", tiles[i] === t);
      });
  };
  btn.addEventListener("click", function () {
    var t = selected(),
      q = +t.dataset.qty || 1;
    window.__addToCart && window.__addToCart("box", q);
  });
  bar.classList.add("show"); // always visible on the product page
  window.__syncSticky();
})();
(function () {
  var DUR = 12000,
    shown = false,
    visible = false,
    tmr = null,
    w = document.getElementById("upsell");
  if (!w || !window.__addToCart) return;
  var fill = document.getElementById("upsellFill");
  function close() {
    if (!visible) return;
    visible = false;
    w.classList.remove("show");
    if (tmr) {
      clearTimeout(tmr);
      tmr = null;
    }
    if (window.__openCart) window.__openCart();
  }
  function open() {
    if (shown) return;
    shown = true;
    visible = true;
    w.classList.add("show");
    fill.style.transition = "none";
    fill.style.width = "0%";
    void fill.offsetWidth;
    fill.style.transition = "width " + DUR + "ms linear";
    fill.style.width = "100%";
    tmr = setTimeout(close, DUR);
  }
  var yes = document.getElementById("upsellYes");
  if (yes)
    yes.addEventListener("click", function () {
      window.__addToCart("app");
      close();
    });
  ["upsellNo", "upsellSkip"].forEach(function (id) {
    var b = document.getElementById(id);
    if (b) b.addEventListener("click", close);
  });
  w.addEventListener("click", function (e) {
    if (e.target === w) close();
  });
  var _add = window.__addToCart;
  window.__addToCart = function (key, qty) {
    var r = _add(key, qty);
    if (key === "box" && !shown && !visible) open();
    return r;
  };
})();
(function () {
  try {
    var s = parseFloat(localStorage.getItem("zc_disc"));
    if (s && s < 1 && window.__applyDiscount) window.__applyDiscount(s);
    var n = localStorage.getItem("zc_name");
    if (n && window.__applyName) window.__applyName(n);
  } catch (e) {}
})();
(function () {
  var s2 = document.getElementById("rcStep2");
  if (!s2) return;
  var ph = document.getElementById("rewardPhone"),
    cc = document.getElementById("rewardCc"),
    u = document.getElementById("rcUnlock"),
    skip = document.getElementById("rcSkip"),
    ov = document.getElementById("rewardModal");
  /* preselect the visitor's dial code from their Shopify market country */
  if (cc && window.ZC && ZC.country) {
    var opt = cc.querySelector('option[data-iso="' + ZC.country + '"]');
    if (opt) opt.selected = true;
  }
  function digits() {
    return ph ? ph.value.replace(/[^0-9]/g, "") : "";
  }
  function vP() {
    var d = digits();
    return d.length >= 6 && d.length <= 14;
  }
  function fullPhone() {
    return (cc ? cc.value : "") + digits().replace(/^0+/, "");
  }
  function upd() {
    if (u) u.disabled = !vP();
  }
  if (ph) ph.addEventListener("input", upd);
  upd();
  if (u)
    u.addEventListener("click", function () {
      if (!vP()) return;
      if (window.__applyDiscount) window.__applyDiscount(0.85);
      try {
        localStorage.setItem("zc_phone", fullPhone());
      } catch (e) {}
      if (window.captureLead) {
        var em = "",
          nm = "";
        try {
          em = localStorage.getItem("zc_email") || "";
          nm = localStorage.getItem("zc_name") || "";
        } catch (e) {}
        window.captureLead({
          email: em,
          name: nm,
          phone: fullPhone(),
          tags: "welcome-popup,welcome-15-unlocked,sms-optin",
        });
      }
      if (ov) ov.classList.remove("show");
    });
  if (skip)
    skip.addEventListener("click", function () {
      if (ov) ov.classList.remove("show");
    });
})();
/* ---- next script block ---- */
(function () {
  var tr = document.getElementById("upTrack"),
    dots = document.getElementById("upDots");
  if (!tr || !dots) return;
  var n = tr.children.length,
    cur = 0,
    sx = 0,
    drag = false;
  function go(i) {
    cur = Math.max(0, Math.min(n - 1, i));
    tr.style.transform = "translateX(-" + (cur * 100) / n + "%)";
    [].forEach.call(dots.children, function (d, k) {
      d.classList.toggle("active", k === cur);
    });
  }
  [].forEach.call(dots.children, function (d, k) {
    d.addEventListener("click", function () {
      go(k);
    });
  });
  tr.addEventListener("pointerdown", function (e) {
    drag = true;
    sx = e.clientX;
    tr.style.transition = "none";
  });
  window.addEventListener("pointerup", function (e) {
    if (!drag) return;
    drag = false;
    tr.style.transition = "";
    var dx = e.clientX - sx;
    if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
    else go(cur);
  });
})();
/* ---- next script block ---- */
/*
 * Reviews thin-seam. getReviews() returns a STATIC array today. To go live,
 * swap the body for a Judge.me fetch() (return the same-shaped array) and NO
 * caller changes are needed — the renderer below is fully data-driven.
 * Shape: { name, location, rating(1-5), headline, quote, verified,
 *          avatarColor, photo? }
 * avatarColor is a brand token name: "rose" | "ink" | "rose-deep".
 * photo is an OPTIONAL image URL (e.g. a Judge.me review photo); when present
 * the card renders it. The 3 static reviews have none — do not invent photos.
 */
function getReviews() {
  return [
    {
      name: "Mohamad I.",
      location: "France",
      rating: 5,
      headline: "Breaks the ice, goes deep",
      quote:
        "A wide variety of thoughtful questions. The easiest way to break the ice and get to know someone on a deeper level.",
      verified: true,
      avatarColor: "rose",
      photo: window.ZC && ZC.assetBase ? ZC.assetBase + "review-1.jpg" : "",
    },
    {
      name: "Stephan M.",
      location: "France",
      rating: 5,
      headline: "Genuinely thoughtful",
      quote:
        "You can tell so much thought went into the questions, genuinely helpful for getting to know a potential spouse.",
      verified: true,
      avatarColor: "ink",
    },
    {
      name: "Ifra A.",
      location: "Australia",
      rating: 5,
      headline: "Saves so much time",
      quote:
        "Saves time. Everything in one place, with questions that make you pause and actually evaluate. Loved it.",
      verified: true,
      avatarColor: "rose-deep",
      photo: window.ZC && ZC.assetBase ? ZC.assetBase + "review-2.jpg" : "",
    },
  ];
}
(function () {
  var track = document.getElementById("revTrack"),
    modalList = document.getElementById("revModalList");
  if (!track && !modalList) return;
  var reviews = getReviews();

  var VERIFIED_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

  function esc(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  function initials(name) {
    var p = String(name).trim().split(/\s+/);
    var a = p[0] ? p[0][0] : "";
    var b = p.length > 1 ? p[p.length - 1][0] : "";
    return (a + b).toUpperCase();
  }
  function stars(n) {
    var r = Math.max(0, Math.min(5, n | 0));
    var out = "";
    for (var i = 0; i < 5; i++) out += i < r ? "★" : "☆";
    return out;
  }
  function cardHTML(r) {
    var color =
      { rose: "var(--rose)", ink: "var(--ink)", "rose-deep": "var(--rose-deep)" }[r.avatarColor] ||
      "var(--rose)";
    return (
      '<div class="review" role="listitem">' +
      '<div class="rv-top">' +
      '<span class="rv-av" style="--c:' +
      color +
      '">' +
      esc(initials(r.name)) +
      "</span>" +
      '<div class="rv-id"><b>' +
      esc(r.name) +
      "</b><small>" +
      esc(r.location) +
      "</small></div>" +
      (r.verified ? '<span class="rv-verified">' + VERIFIED_SVG + "Verified</span>" : "") +
      "</div>" +
      '<div class="stars" aria-label="' +
      r.rating +
      ' out of 5 stars">' +
      stars(r.rating) +
      "</div>" +
      '<div class="rv-headline">' +
      esc(r.headline) +
      "</div>" +
      "<p>&ldquo;" +
      esc(r.quote) +
      "&rdquo;</p>" +
      (r.photo
        ? '<img class="rv-photo" loading="lazy" decoding="async" src="' +
          esc(r.photo) +
          '" alt="Photo from ' +
          esc(r.name) +
          '&rsquo;s review">'
        : "") +
      "</div>"
    );
  }

  var html = reviews.map(cardHTML).join("");
  if (track) track.innerHTML = html;
  if (modalList) modalList.innerHTML = html;

  var count = document.getElementById("revCount");
  if (count) count.textContent = reviews.length + " review" + (reviews.length === 1 ? "" : "s");
})();
/* ---- next script block ---- */
(function () {
  var b = document.getElementById("revMore"),
    m = document.getElementById("revModal"),
    x = document.getElementById("revModalX");
  if (!b || !m) return;
  function op() {
    m.classList.add("show");
    m.setAttribute("aria-hidden", "false");
  }
  function cl() {
    m.classList.remove("show");
    m.setAttribute("aria-hidden", "true");
  }
  b.addEventListener("click", op);
  if (x) x.addEventListener("click", cl);
  m.addEventListener("click", function (e) {
    if (e.target === m) cl();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") cl();
  });
})();
/* ---- next script block ---- */
(function () {
  var cb = document.getElementById("rewardClaim"),
    nm = document.getElementById("rewardName"),
    em = document.getElementById("rewardEmail");
  function vE() {
    return em && /.+@.+\..+/.test(em.value);
  }
  function upd() {
    if (cb) cb.disabled = !vE();
  }
  if (cb) {
    cb.disabled = true;
    [nm, em].forEach(function (x) {
      if (x) x.addEventListener("input", upd);
    });
    upd();
  }
})();
/* ---- next script block ---- */
(function () {
  try {
    if (localStorage.getItem("zc_gift_unlocked") !== "1") return;
  } catch (e) {
    return;
  }
  if (document.getElementById("zcgift-badge")) return;
  var css =
    ".zcgift-badge{position:fixed;right:18px;bottom:20px;z-index:9000;display:flex;flex-direction:column;align-items:center;gap:5px;cursor:pointer;animation:zcgpop .35s cubic-bezier(.34,1.56,.64,1)}@keyframes zcgpop{from{transform:scale(.6)}to{transform:none}}.zcgift-badge .zp{background:#E8DC5B;color:#241B14;font-family:'Neulis Neue',sans-serif;font-weight:800;font-size:.86rem;padding:8px 14px;border-radius:100px;box-shadow:0 6px 18px rgba(36,27,20,.28);white-space:nowrap}.zcgift-badge img{width:40px;height:auto;filter:drop-shadow(0 3px 6px rgba(36,27,20,.3))}.zcgift-modal{position:fixed;inset:0;z-index:9001;background:rgba(36,27,20,.6);display:none;align-items:center;justify-content:center;padding:20px}.zcgift-modal.on{display:flex}.zcgift-modal .sh{background:#FFFDF7;border-radius:24px;padding:26px 24px 30px;width:100%;max-width:440px;animation:zcgin .3s cubic-bezier(.34,1.56,.64,1);font-family:Montserrat,sans-serif}@keyframes zcgin{from{opacity:0;transform:scale(.9)}to{opacity:1;transform:none}}.zcgift-modal .hd{display:flex;align-items:center;justify-content:space-between;margin-bottom:16px}.zcgift-modal .hd h3{font-family:'Neulis Neue',sans-serif;font-weight:600;font-size:1.18rem;color:#241B14;margin:0}.zcgift-modal .cl{background:none;border:none;cursor:pointer;font-size:1.5rem;color:#574C40;line-height:1}.zcgift-modal .row{display:flex;gap:14px;align-items:center;background:#F2E9C2;border-radius:16px;padding:14px;margin-bottom:16px}.zcgift-modal .cov{width:60px;flex:0 0 auto;aspect-ratio:2/3;border-radius:8px;overflow:hidden;background:#D32C51;display:grid;place-items:center}.zcgift-modal .cov img{width:100%;height:100%;object-fit:cover}.zcgift-modal .nfo h4{font-family:'Neulis Neue',sans-serif;font-weight:600;font-size:.98rem;color:#241B14;margin:0 0 4px}.zcgift-modal .nfo .ds{font-size:.82rem;color:#574C40;line-height:1.45;margin:0 0 7px}.zcgift-modal .nfo .pr{font-family:'Neulis Neue',sans-serif;font-weight:800;font-size:1.08rem;color:#D32C51;display:flex;align-items:baseline;gap:8px}.zcgift-modal .nfo .pr del{color:#574C40;font-weight:600;font-size:.84rem}.zcgift-modal .ad{display:block;width:100%;border:none;cursor:pointer;font-family:'Neulis Neue',sans-serif;font-weight:700;font-size:1.02rem;color:#fff;background:#D32C51;border-radius:100px;padding:15px;box-shadow:0 10px 26px -12px #D32C51}.zcgift-modal .gr{text-align:center;margin-top:11px;font-size:.74rem;color:#574C40;font-weight:600}";
  var st = document.createElement("style");
  st.textContent = css;
  document.head.appendChild(st);
  var b = document.createElement("div");
  b.id = "zcgift-badge";
  b.className = "zcgift-badge";
  b.setAttribute("role", "button");
  b.setAttribute("aria-label", "View your 50% off gift");
  b.innerHTML =
    '<div class="zp">50% Off</div><img src=ZC.assetBase + "sticker-flowers.png" alt="">';
  var m = document.createElement("div");
  m.className = "zcgift-modal";
  m.innerHTML =
    '<div class="sh"><div class="hd"><h3>Your unlocked gift</h3><button class="cl" aria-label="Close">&times;</button></div><div class="row"><div class="cov"><img src=ZC.assetBase + "book-cover.jpg" alt="" onerror="this.style.display=\'none\'"></div><div class="nfo"><h4>10 Steps to Get Married</h4><p class="ds">Your guide to approaching marriage the right way, from getting ready to finding the one.</p><div class="pr"><del>\u00a325</del> \u00a312.50</div></div></div><button class="ad">Add to basket &rarr;</button><p class="gr">50% off applied automatically. 30-day money-back guarantee.</p></div>';
  document.body.appendChild(b);
  document.body.appendChild(m);
  b.addEventListener("click", function () {
    m.classList.add("on");
  });
  m.querySelector(".cl").addEventListener("click", function () {
    m.classList.remove("on");
  });
  m.addEventListener("click", function (e) {
    if (e.target === m) m.classList.remove("on");
  });
  m.querySelector(".ad").addEventListener("click", function () {
    window.location.href = "zawaj_product_page_v2.html#offer";
  });
})();
/* ---- next script block ---- */
(function () {
  var ANCHOR = [".salepop", ".upsell"],
    MOVE = ["#zcgift-badge", ".revbadge"];
  function vis(e) {
    if (!e) return false;
    var s = getComputedStyle(e);
    if (s.display === "none" || s.visibility === "hidden" || parseFloat(s.opacity) === 0)
      return false;
    var r = e.getBoundingClientRect();
    return r.width > 1 && r.height > 1;
  }
  function over(a, b) {
    return !(
      a.right < b.left - 8 ||
      a.left > b.right + 8 ||
      a.bottom < b.top - 8 ||
      a.top > b.bottom + 8
    );
  }
  function gather(list) {
    var out = [];
    list.forEach(function (s) {
      Array.prototype.forEach.call(document.querySelectorAll(s), function (e) {
        out.push(e);
      });
    });
    return out;
  }
  function resolve() {
    gather(ANCHOR.concat(MOVE)).forEach(function (e) {
      e.style.bottom = "";
    });
    var placed = gather(ANCHOR).filter(vis);
    gather(MOVE).forEach(function (e) {
      if (!vis(e)) return;
      var base = parseFloat(getComputedStyle(e).bottom) || 20;
      e.style.setProperty("bottom", base + "px", "important");
      var r = e.getBoundingClientRect(),
        guard = 0;
      while (guard++ < 24) {
        var hit = null;
        for (var k = 0; k < placed.length; k++) {
          if (placed[k] === e) continue;
          var p = placed[k].getBoundingClientRect();
          if (over(r, p)) {
            hit = p;
            break;
          }
        }
        if (!hit) break;
        base += r.bottom - hit.top + 12;
        e.style.setProperty("bottom", base + "px", "important");
        r = e.getBoundingClientRect();
      }
      placed.push(e);
    });
  }
  var raf;
  function schedule() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(resolve);
  }
  window.addEventListener("resize", schedule);
  window.addEventListener("scroll", schedule, { passive: true });
  new MutationObserver(schedule).observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "style", "hidden"],
    childList: true,
  });
  setInterval(resolve, 500);
  schedule();
})();
/* ---- next script block ---- */
(function () {
  var b = document.querySelector(".menu-btn"),
    m = document.getElementById("mnav");
  if (b && m) {
    var tb = document.querySelector(".topbar");
    function setTop() {
      var bt = tb ? tb.getBoundingClientRect().bottom : 0;
      m.style.setProperty("--mnav-top", Math.max(0, bt) + "px");
    }
    function open() {
      document.documentElement.classList.add("menu-open");
      document.body.classList.add("menu-open");
      setTop();
      m.classList.add("open");
      b.classList.add("open");
      b.setAttribute("aria-expanded", "true");
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    }
    function c() {
      m.classList.remove("open");
      b.classList.remove("open");
      b.setAttribute("aria-expanded", "false");
      document.documentElement.classList.remove("menu-open");
      document.body.classList.remove("menu-open");
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    }
    b.addEventListener("click", function () {
      m.classList.contains("open") ? c() : open();
    });
    m.addEventListener("click", function (e) {
      if (e.target === m) c();
    });
    m.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", c);
    });
    window.addEventListener("resize", function () {
      if (m.classList.contains("open")) setTop();
    });
  }
  var cd = document.getElementById("cartDrawer");
  if (cd) {
    new MutationObserver(function () {
      document.body.classList.toggle("cart-open", cd.classList.contains("show"));
    }).observe(cd, { attributes: true, attributeFilter: ["class"] });
  }
})();
/* ---- next script block ---- */

(function () {
  document.querySelectorAll(".yt-facade").forEach(function (b) {
    b.addEventListener("click", function () {
      var id = b.getAttribute("data-yt");
      b.parentNode.innerHTML =
        '<iframe src="https://www.youtube.com/embed/' +
        id +
        '?autoplay=1&rel=0&modestbranding=1&playsinline=1" title="' +
        (b.getAttribute("aria-label") || "") +
        '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
    });
  });
})();

function zcConfetti(x, y) {
  var colors = ["#D32C51", "#E8DC5B", "#FAF4D8", "#B3203F"];
  for (var i = 0; i < 18; i++) {
    var p = document.createElement("span");
    p.className = "zc-confetti";
    p.style.left = x + "px";
    p.style.top = y + "px";
    p.style.background = colors[i % colors.length];
    var ang = Math.random() * Math.PI * 2;
    var dist = 40 + Math.random() * 70;
    p.style.setProperty("--dx", Math.cos(ang) * dist + "px");
    p.style.setProperty("--dy", Math.sin(ang) * dist - 50 + "px");
    p.style.animationDelay = Math.random() * 0.08 + "s";
    document.body.appendChild(p);
    (function (el) {
      setTimeout(function () {
        el.remove();
      }, 1000);
    })(p);
  }
}
(function () {
  var cta = document.getElementById("homeOfferCta");
  if (!cta) return;
  var opts = [].slice.call(document.querySelectorAll(".opt[data-opt]"));
  function sel() {
    return document.querySelector(".opt[data-opt].sel") || opts[0];
  }
  function priceTxt(o) {
    if (o.dataset.opt === "box") {
      var pb = document.getElementById("priceBox");
      var c = pb ? +pb.getAttribute("data-cents") : 0;
      if (c) return window.__zcMoney((c / 100) * (window.__disc || 1));
    }
    return o.dataset.price || "";
  }
  function upd() {
    var o = sel();
    if (!o) return;
    cta.textContent = "Add " + (o.dataset.label || "to cart") + " to cart · " + priceTxt(o);
  }
  window.__zcHomeOffer = upd;
  opts.forEach(function (o) {
    o.addEventListener("click", function () {
      opts.forEach(function (x) {
        x.classList.remove("sel");
      });
      o.classList.add("sel");
      upd();
    });
  });
  cta.addEventListener("click", function () {
    var o = sel();
    window.__addToCart && window.__addToCart(o ? o.dataset.opt : "box", 1);
  });
  upd();
})();

(function () {
  var el = document.getElementById("zcRating");
  if (!el) return;
  function render(avg, ct) {
    var a = document.getElementById("zcRatingAvg");
    var c = document.getElementById("zcRatingCt");
    if (a) a.textContent = avg;
    if (c) c.textContent = ct + " verified reviews \u203a";
    el.hidden = false;
  }
  try {
    var cached = sessionStorage.getItem("zc_fera_rating");
    if (cached) {
      var d = JSON.parse(cached);
      render(d.a, d.c);
      return;
    }
  } catch (e) {}
  var pk = null;
  [].some.call(document.scripts, function (sc) {
    var m = (sc.textContent || "").match(/pk_[a-f0-9]{48,}/);
    if (m) {
      pk = m[0];
      return true;
    }
  });
  if (!pk) return;
  fetch("https://api.fera.ai/v3/public/store?api_key=" + pk)
    .then(function (r) {
      return r.json();
    })
    .then(function (j) {
      var r = (j && j.rating) || {};
      var avg = r.average,
        ct = r.count;
      if (!avg || !ct) return;
      avg = Math.round(avg * 10) / 10;
      try {
        sessionStorage.setItem("zc_fera_rating", JSON.stringify({ a: avg, c: ct }));
      } catch (e) {}
      render(avg, ct);
    })
    .catch(function () {});
})();

/* World map: routes from the UK to every shipped-to country, dot + name tooltip */
(function () {
  var wrap = document.querySelector(".mapwrap");
  var tip = document.getElementById("wmTip");
  var dataEl = document.getElementById("zcShipped");
  if (!wrap || !tip || !dataEl) return;
  var svg = wrap.querySelector(".wm-svg");
  if (!svg) return;
  var names;
  try {
    names = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var NS = "http://www.w3.org/2000/svg";
  var UK = { x: 401.7, y: 381.9 };
  /* bbox centers are wrong for multi-part territories; hk/bh/cx have no path at all */
  var FIX = {
    gb: UK,
    us: { x: 240, y: 424 },
    ca: { x: 210, y: 342 },
    no: { x: 427, y: 346 },
    hk: { x: 681, y: 466 },
    bh: { x: 526.3, y: 462.3 },
    cx: { x: 661, y: 558 },
  };
  var lines = document.createElementNS(NS, "g");
  lines.setAttribute("class", "wm-lines");
  var nodes = document.createElementNS(NS, "g");
  svg.appendChild(lines);
  svg.appendChild(nodes);
  var made = [];
  Object.keys(names).forEach(function (code) {
    var el = svg.querySelector("#" + code);
    var pt = FIX[code];
    if (!pt) {
      if (!el) return;
      try {
        var b = el.getBBox();
        pt = { x: b.x + b.width / 2, y: b.y + b.height / 2 };
      } catch (e) {
        return;
      }
    }
    if (el) {
      el.classList.add("wm-on");
      el.setAttribute("data-name", names[code]);
    }
    var g = document.createElementNS(NS, "g");
    g.setAttribute(
      "class",
      "wm-node" + (code === "ps" ? " wm-ps" : "") + (code === "gb" ? " wm-hub" : ""),
    );
    g.setAttribute("data-name", names[code]);
    var hit = document.createElementNS(NS, "circle");
    hit.setAttribute("class", "hit");
    hit.setAttribute("cx", pt.x);
    hit.setAttribute("cy", pt.y);
    hit.setAttribute("r", 8);
    var c = document.createElementNS(NS, "circle");
    c.setAttribute("class", "c");
    c.setAttribute("cx", pt.x);
    c.setAttribute("cy", pt.y);
    c.setAttribute("r", code === "gb" ? 4 : code === "ps" ? 3.2 : 2.6);
    g.appendChild(hit);
    g.appendChild(c);
    nodes.appendChild(g);
    var ln = null;
    if (code !== "gb") {
      ln = document.createElementNS(NS, "path");
      var mx = (UK.x + pt.x) / 2;
      var my = (UK.y + pt.y) / 2;
      var lift = Math.min(60, Math.hypot(pt.x - UK.x, pt.y - UK.y) * 0.18);
      ln.setAttribute(
        "d",
        "M" + UK.x + " " + UK.y + " Q" + mx + " " + (my - lift) + " " + pt.x + " " + pt.y,
      );
      lines.appendChild(ln);
    }
    made.push({ dot: c, line: ln, el: el });
  });
  /* start empty: routes draw out from the UK one by one, dot lands at the end */
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  made.forEach(function (m) {
    if (m.line) {
      var L = m.line.getTotalLength();
      m.line.style.strokeDasharray = L;
      m.line.style.strokeDashoffset = L;
    }
    m.dot.style.opacity = 0;
  });
  function fillDelay(el, v) {
    el.style.transitionDelay = v;
    [].forEach.call(el.querySelectorAll("path"), function (p) {
      p.style.transitionDelay = v;
    });
  }
  function go() {
    made.forEach(function (m, i) {
      var d = reduce ? 0 : i * 160;
      if (m.line) {
        m.line.style.transition = "stroke-dashoffset 1s ease " + d + "ms";
        m.line.style.strokeDashoffset = 0;
      }
      m.dot.style.transition = "opacity 0.5s ease " + (d + (m.line ? 750 : 0)) + "ms";
      m.dot.style.opacity = 1;
      if (m.el) fillDelay(m.el, d + (m.line ? 700 : 0) + "ms");
    });
    svg.classList.add("wm-go");
    var total = made.length * 160 + 1900;
    setTimeout(
      function () {
        svg.classList.add("wm-done");
        made.forEach(function (m) {
          m.dot.style.opacity = "";
          m.dot.style.transition = "";
          if (m.el) fillDelay(m.el, "");
        });
      },
      reduce ? 0 : total,
    );
  }
  if ("IntersectionObserver" in window && !reduce) {
    var io = new IntersectionObserver(
      function (en) {
        if (en[0].isIntersecting) {
          io.disconnect();
          go();
        }
      },
      { threshold: 0.6 },
    );
    io.observe(wrap);
  } else {
    go();
  }
  function show(e) {
    var t = e.target.closest ? e.target.closest(".wm-node") || e.target.closest(".wm-on") : null;
    if (!t) {
      tip.hidden = true;
      return;
    }
    tip.textContent = t.getAttribute("data-name");
    tip.hidden = false;
    var r = wrap.getBoundingClientRect();
    tip.style.left = e.clientX - r.left + "px";
    tip.style.top = e.clientY - r.top + "px";
  }
  svg.addEventListener("pointermove", show);
  svg.addEventListener("pointerdown", show);
  svg.addEventListener("pointerleave", function () {
    tip.hidden = true;
  });
})();
